import { useEffect, useState } from "react";

import moment from "moment";

import * as CanDataEVSolution from "../../commons/CanDataEVSolution";

import * as Common from "../../commons/common";
import * as TypeDTO from "../../commons/typeDTO";
import * as TypeUtils from "../../commons/typeUtils";

import CanDataWrapper, { CanTableType } from "./CanDataWrapper";
import Space from "antd/es/space/index";

function CanDataEVSolutionViewer({
    loading,
    vehicleInfo,
    runningCanDataList,
    noFileteredCount,
    selectedDataPointIndex,
    onChangedSelectDataPointIndex,
    onMountedChart,
    onZoomed,
}: {
    loading: boolean;
    vehicleInfo?: TypeDTO.CarDto | undefined;
    runningCanDataList?: Array<TypeDTO.CanData> | undefined;
    noFileteredCount: number;
    selectedDataPointIndex?: number;
    onChangedSelectDataPointIndex?: (dataPointIndex: number) => void;
    onMountedChart?: () => void;
    onZoomed?: (zoom: any) => void;
}) {
    const [currentCanData, setCurrentCanData] = useState<CanDataEVSolution.CanData>();

    const convertRemarkWithUnit = (value: number, unit: string) => {
        return value + unit;
    };

    const convertRemarkBatPackStatus = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Normal";
                break;
            case 1:
                valueString = "Warning";
                break;
            case 2:
                valueString = "Warning(VCU),MIL(Cluster)";
                break;
            case 3:
                valueString = "Warning,MIL,Derating";
                break;
            case 4:
                valueString = "Warning,MIL,Fault,Rel off by VCU";
                break;
            case 5:
                valueString = "Warning,MIL,Critical,Rel off BMS";
                break;

            default:
                break;
        }
        return valueString;
    };

    const convertRemarkOperationMode = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Sleep";
                break;
            case 1:
                valueString = "Standby";
                break;
            case 2:
                valueString = "Pre-charge";
                break;
            case 3:
                valueString = "Ready";
                break;
            case 4:
                valueString = "Error";
                break;
            case 5:
                valueString = "Shutdown";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkContactorCoilState = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "OFF";
                break;
            case 1:
                valueString = "ON";
                break;
            case 2:
                valueString = "Open Load";
                break;
            case 3:
                valueString = "Short to GND";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkFault = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Fault";
                break;
            case 1:
                valueString = "Normal";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkRequest = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "NoRequest";
                break;
            case 1:
                valueString = "Request";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkBmsMode = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Standby";
                break;
            case 1:
                valueString = "Heating mode";
                break;
            case 2:
                valueString = "Cooling mode";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkNoYes = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "No";
                break;
            case 1:
                valueString = "Yes";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkCoolingPumpFeedbackStatus = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Not working";
                break;
            case 1:
                valueString = "PWM Wire open";
                break;
            case 2:
                valueString = "Dry run signal";
                break;
            case 3:
                valueString = "STALL";
                break;
            case 4:
                valueString = "Over temp";
                break;
            case 5:
                valueString = "EWP diagnostic fault";
                break;
            case 6:
                valueString = "Reserved";
                break;
            case 7:
                valueString = "Normal working";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkBhcStsOwTs = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Normal state";
                break;
            case 1:
                valueString = "abnormality";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkBhcStsErr = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "no_error";
                break;
            case 1:
                valueString = "HV Heater Relay Coil Error";
                break;
            case 2:
                valueString = "Heater Internal Error";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkError = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "No Error";
                break;
            case 1:
                valueString = "Error";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkMonitoring = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Monitoring";
                break;
            case 1:
                valueString = "Stop Monitoring";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkTorqueMode = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Torque Mode";
                break;
            case 3:
                valueString = "Invalid";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkOperationalModeCmd = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "Neutral";
                break;
            case 3:
                valueString = "Ev";
                break;
            case 7:
                valueString = "Invalid";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkPdStat = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "unplugged";
                break;
            case 1:
                valueString = "Plug-in";
                break;
            case 2:
                valueString = "S3 Open";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkEvseChgFinished = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "not finished";
                break;
            case 1:
                valueString = "finished";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkGearStateEhbi = (value: number) => {
        let valueString = "-";
        if (!value) return valueString;
        switch (value) {
            case 0:
                valueString = "None";
                break;
            case 1:
                valueString = "P";
                break;
            case 2:
                valueString = "R";
                break;
            case 3:
                valueString = "N";
                break;
            case 4:
                valueString = "D";
                break;
            default:
                break;
        }
        return valueString;
    };

    //#region Bms1D9
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bms1D9PanelOpen, setBms1D9PanelOpen] = useState(false);
    const [bms1D9ChartMounted, setBms1D9ChartMounted] = useState(false);
    const [selectedBms1D9, setSelectedBms1D9] = useState<Array<React.Key>>([]);

    const [seriesChartDatasBms1D9, setSeriesChartDatasBms1D9] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBms1D9BatPackStatus, setChartBms1D9BatPackStatus] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_BAT_PACK_STATUS_NAME,
        data: [],
    });

    const [chartBms1D9OperationMode, setChartBms1D9OperationMode] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_OPERATION_MODE_NAME,
        data: [],
    });

    const [chartBms1D9DcLinkVolt, setChartBms1D9DcLinkVolt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_DC_LINK_VOLT_NAME,
        data: [],
    });

    const [chartBms1D9BatPackCurr, setChartBms1D9BatPackCurr] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_BAT_PACK_CURR_NAME,
        data: [],
    });

    const [chartBms1D9MainMinusContactorCoilState, setChartBms1D9MainMinusContactorCoilState] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_COIL_STATE_NAME,
        data: [],
    });

    const [chartBms1D9MainPlusContactorCoilState, setChartBms1D9MainPlusContactorCoilState] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_COIL_STATE_NAME,
        data: [],
    });

    const [chartBms1D9PreChargeContactorCoilState, setChartBms1D9PreChargeContactorCoilState] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_COIL_STATE_NAME,
        data: [],
    });

    const [chartBms1D9IgnStat, setChartBms1D9IgnStat] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_IGN_STAT_NAME,
        data: [],
    });

    const [chartBms1D9HvilStatus, setChartBms1D9HvilStatus] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_HVIL_STATUS_NAME,
        data: [],
    });

    const [chartBms1D9Counter, setChartBms1D9Counter] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_COUNTER_NAME,
        data: [],
    });

    const [chartBms1D9MainMinusContactorState, setChartBms1D9MainMinusContactorState] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_STATE_NAME,
        data: [],
    });

    const [chartBms1D9MainPlusContactorState, setChartBms1D9MainPlusContactorState] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_STATE_NAME,
        data: [],
    });

    const [chartBms1D9PreChargeContactorState, setChartBms1D9PreChargeContactorState] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_STATE_NAME,
        data: [],
    });

    const [chartBms1D9ContactorOffRequest, setChartBms1D9ContactorOffRequest] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_CONTACTOR_OFF_REQUEST_NAME,
        data: [],
    });

    const [chartBms1D9Checksum, setChartBms1D9Checksum] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B1_CHECKSUM_NAME,
        data: [],
    });

    const getBms1D9BatPackStatusValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_BAT_PACK_STATUS_KEY) && currentCanData !== undefined) {
            return convertRemarkBatPackStatus(currentCanData.bms1D9?.batPackStatus);
        }
        return "-";
    };

    const getBms1D9OperationModeValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_OPERATION_MODE_KEY) && currentCanData !== undefined) {
            return convertRemarkOperationMode(currentCanData.bms1D9?.operationMode);
        }
        return "-";
    };

    const getBms1D9DcLinkVoltValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_DC_LINK_VOLT_KEY) && currentCanData !== undefined) {
            return convertRemarkWithUnit(currentCanData.bms1D9?.dcLinkVolt, Common.UNIT_VOLTAGE);
        }
        return "-";
    };

    const getBms1D9BatPackCurrValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_BAT_PACK_CURR_KEY) && currentCanData !== undefined) {
            return convertRemarkWithUnit(currentCanData.bms1D9?.batPackCurr, Common.UNIT_CURRENT);
        }
        return "-";
    };

    const getBms1D9MainMinusContactorCoilStateValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_COIL_STATE_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.bms1D9?.mainMinusContactorCoilState);
        }
        return "-";
    };

    const getBms1D9MainPlusContactorCoilStateValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_COIL_STATE_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.bms1D9?.mainPlusContactorCoilState);
        }
        return "-";
    };

    const getBms1D9PreChargeContactorCoilStateValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_COIL_STATE_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.bms1D9?.preChargeContactorCoilState);
        }
        return "-";
    };

    const getBms1D9IgnStatValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_IGN_STAT_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.bms1D9?.ignStat);
        }
        return "-";
    };

    const getBms1D9HvilStatusValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_HVIL_STATUS_KEY) && currentCanData !== undefined) {
            return convertRemarkFault(currentCanData.bms1D9?.hvilStatus);
        }
        return "-";
    };

    const getBms1D9CounterValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_COUNTER_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms1D9?.counter);
        }
        return "-";
    };

    const getBms1D9MainMinusContactorStateValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_STATE_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.bms1D9?.mainMinusContactorState);
        }
        return "-";
    };

    const getBms1D9MainPlusContactorStateValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_STATE_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.bms1D9?.mainPlusContactorState);
        }
        return "-";
    };

    const getBms1D9PreChargeContactorStateValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_STATE_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.bms1D9?.preChargeContactorState);
        }
        return "-";
    };

    const getBms1D9ContactorOffRequestValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_CONTACTOR_OFF_REQUEST_KEY) && currentCanData !== undefined) {
            return convertRemarkRequest(currentCanData.bms1D9?.contactorOffRequest);
        }
        return "-";
    };

    const getBms1D9ChecksumValue = () => {
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_CHECKSUM_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms1D9?.checksum);
        }
        return "-";
    };

    const onChangeBms1D9 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBms1D9(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBms1D9: Array<TypeUtils.ChartData> = [];

        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_BAT_PACK_STATUS_KEY)) chartDatasBms1D9.push(chartBms1D9BatPackStatus);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_OPERATION_MODE_KEY)) chartDatasBms1D9.push(chartBms1D9OperationMode);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_DC_LINK_VOLT_KEY)) chartDatasBms1D9.push(chartBms1D9DcLinkVolt);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_BAT_PACK_CURR_KEY)) chartDatasBms1D9.push(chartBms1D9BatPackCurr);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_COIL_STATE_KEY))
            chartDatasBms1D9.push(chartBms1D9MainMinusContactorCoilState);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_COIL_STATE_KEY))
            chartDatasBms1D9.push(chartBms1D9MainPlusContactorCoilState);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_COIL_STATE_KEY))
            chartDatasBms1D9.push(chartBms1D9PreChargeContactorCoilState);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_IGN_STAT_KEY)) chartDatasBms1D9.push(chartBms1D9IgnStat);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_HVIL_STATUS_KEY)) chartDatasBms1D9.push(chartBms1D9HvilStatus);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_COUNTER_KEY)) chartDatasBms1D9.push(chartBms1D9Counter);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_STATE_KEY)) chartDatasBms1D9.push(chartBms1D9MainMinusContactorState);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_STATE_KEY)) chartDatasBms1D9.push(chartBms1D9MainPlusContactorState);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_STATE_KEY)) chartDatasBms1D9.push(chartBms1D9PreChargeContactorState);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_CONTACTOR_OFF_REQUEST_KEY)) chartDatasBms1D9.push(chartBms1D9ContactorOffRequest);
        if (selectedBms1D9.includes(Common.EVSOLUTION_B1_CHECKSUM_KEY)) chartDatasBms1D9.push(chartBms1D9Checksum);

        setSeriesChartDatasBms1D9(chartDatasBms1D9);
    }, [
        selectedBms1D9,
        chartBms1D9BatPackStatus,
        chartBms1D9OperationMode,
        chartBms1D9DcLinkVolt,
        chartBms1D9BatPackCurr,
        chartBms1D9MainMinusContactorCoilState,
        chartBms1D9MainPlusContactorCoilState,
        chartBms1D9PreChargeContactorCoilState,
        chartBms1D9IgnStat,
        chartBms1D9HvilStatus,
        chartBms1D9Counter,
        chartBms1D9MainMinusContactorState,
        chartBms1D9MainPlusContactorState,
        chartBms1D9PreChargeContactorState,
        chartBms1D9ContactorOffRequest,
        chartBms1D9Checksum,
    ]);

    const tableDataBms1D9: CanTableType[] = [
        {
            key: Common.EVSOLUTION_B1_BAT_PACK_STATUS_KEY,
            name: Common.EVSOLUTION_B1_BAT_PACK_STATUS_NAME,
            value: getBms1D9BatPackStatusValue(),
        },
        {
            key: Common.EVSOLUTION_B1_OPERATION_MODE_KEY,
            name: Common.EVSOLUTION_B1_OPERATION_MODE_NAME,
            value: getBms1D9OperationModeValue(),
        },
        {
            key: Common.EVSOLUTION_B1_DC_LINK_VOLT_KEY,
            name: Common.EVSOLUTION_B1_DC_LINK_VOLT_NAME,
            value: getBms1D9DcLinkVoltValue(),
        },
        {
            key: Common.EVSOLUTION_B1_BAT_PACK_CURR_KEY,
            name: Common.EVSOLUTION_B1_BAT_PACK_CURR_NAME,
            value: getBms1D9BatPackCurrValue(),
        },
        {
            key: Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_COIL_STATE_KEY,
            name: Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_COIL_STATE_NAME,
            value: getBms1D9MainMinusContactorCoilStateValue(),
        },

        {
            key: Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_COIL_STATE_KEY,
            name: Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_COIL_STATE_NAME,
            value: getBms1D9MainPlusContactorCoilStateValue(),
        },
        {
            key: Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_COIL_STATE_KEY,
            name: Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_COIL_STATE_NAME,
            value: getBms1D9PreChargeContactorCoilStateValue(),
        },
        {
            key: Common.EVSOLUTION_B1_IGN_STAT_KEY,
            name: Common.EVSOLUTION_B1_IGN_STAT_NAME,
            value: getBms1D9IgnStatValue(),
        },
        {
            key: Common.EVSOLUTION_B1_HVIL_STATUS_KEY,
            name: Common.EVSOLUTION_B1_HVIL_STATUS_NAME,
            value: getBms1D9HvilStatusValue(),
        },
        {
            key: Common.EVSOLUTION_B1_COUNTER_KEY,
            name: Common.EVSOLUTION_B1_COUNTER_NAME,
            value: getBms1D9CounterValue(),
        },

        {
            key: Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_STATE_KEY,
            name: Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_STATE_NAME,
            value: getBms1D9MainMinusContactorStateValue(),
        },
        {
            key: Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_STATE_KEY,
            name: Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_STATE_NAME,
            value: getBms1D9MainPlusContactorStateValue(),
        },
        {
            key: Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_STATE_KEY,
            name: Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_STATE_NAME,
            value: getBms1D9PreChargeContactorStateValue(),
        },
        {
            key: Common.EVSOLUTION_B1_CONTACTOR_OFF_REQUEST_KEY,
            name: Common.EVSOLUTION_B1_CONTACTOR_OFF_REQUEST_NAME,
            value: getBms1D9ContactorOffRequestValue(),
        },
        {
            key: Common.EVSOLUTION_B1_CHECKSUM_KEY,
            name: Common.EVSOLUTION_B1_CHECKSUM_NAME,
            value: getBms1D9ChecksumValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Bms321
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bms321PanelOpen, setBms321PanelOpen] = useState(false);
    const [bms321ChartMounted, setBms321ChartMounted] = useState(false);
    const [selectedBms321, setSelectedBms321] = useState<Array<React.Key>>([]);

    const [seriesChartDatasBms321, setSeriesChartDatasBms321] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBms321BatPackVolt, setChartBms321BatPackVolt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B2_BAT_PACK_VOLT_NAME,
        data: [],
    });

    const [chartBms321BmsMode, setChartBms321BmsMode] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B2_BMS_MODE_NAME,
        data: [],
    });

    const [chartBms321WaterPumpStatus, setChartBms321WaterPumpStatus] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B2_WATER_PUMP_STATUS_NAME,
        data: [],
    });

    const [chartBms321BalancingStatus, setChartBms321BalancingStatus] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B2_BALANCING_STATUS_NAME,
        data: [],
    });

    const [chartBms321BatPackAsoc, setChartBms321BatPackAsoc] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B2_BAT_PACK_ASOC_NAME,
        data: [],
    });

    const [chartBms321BatPackRsoc, setChartBms321BatPackRsoc] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B2_BAT_PACK_RSOC_NAME,
        data: [],
    });

    const [chartBms321BatPackSoh, setChartBms321BatPackSoh] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B2_BAT_PACK_SOH_NAME,
        data: [],
    });

    const getBms321BatPackVoltValue = () => {
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BAT_PACK_VOLT_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms321?.batPackVolt);
        }
        return "-";
    };

    const getBms321BmsModeValue = () => {
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BMS_MODE_KEY) && currentCanData !== undefined) {
            return convertRemarkBmsMode(currentCanData.bms321?.bmsMode);
        }
        return "-";
    };

    const getBms321WaterPumpStatusValue = () => {
        if (selectedBms321.includes(Common.EVSOLUTION_B2_WATER_PUMP_STATUS_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.bms321?.waterPumpStatus);
        }
        return "-";
    };

    const getBms321BalancingStatusValue = () => {
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BALANCING_STATUS_KEY) && currentCanData !== undefined) {
            return convertRemarkNoYes(currentCanData.bms321?.balancingStatus);
        }
        return "-";
    };

    const getBms321BatPackAsocValue = () => {
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BAT_PACK_ASOC_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms321?.batPackAsoc);
        }
        return "-";
    };

    const getBms321BatPackRsocValue = () => {
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BAT_PACK_RSOC_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms321?.batPackRsoc);
        }
        return "-";
    };

    const getBms321BatPackSohValue = () => {
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BAT_PACK_SOH_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms321?.batPackSoh);
        }
        return "-";
    };

    const onChangeBms321 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBms321(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBms321: Array<TypeUtils.ChartData> = [];

        if (selectedBms321.includes(Common.EVSOLUTION_B2_BAT_PACK_VOLT_KEY)) chartDatasBms321.push(chartBms321BatPackVolt);
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BMS_MODE_KEY)) chartDatasBms321.push(chartBms321BmsMode);
        if (selectedBms321.includes(Common.EVSOLUTION_B2_WATER_PUMP_STATUS_KEY)) chartDatasBms321.push(chartBms321WaterPumpStatus);
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BALANCING_STATUS_KEY)) chartDatasBms321.push(chartBms321BalancingStatus);
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BAT_PACK_ASOC_KEY)) chartDatasBms321.push(chartBms321BatPackAsoc);
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BAT_PACK_RSOC_KEY)) chartDatasBms321.push(chartBms321BatPackRsoc);
        if (selectedBms321.includes(Common.EVSOLUTION_B2_BAT_PACK_SOH_KEY)) chartDatasBms321.push(chartBms321BatPackSoh);

        setSeriesChartDatasBms321(chartDatasBms321);
    }, [
        selectedBms321,
        chartBms321BatPackVolt,
        chartBms321BmsMode,
        chartBms321WaterPumpStatus,
        chartBms321BalancingStatus,
        chartBms321BatPackAsoc,
        chartBms321BatPackRsoc,
        chartBms321BatPackSoh,
    ]);

    const tableDataBms321: CanTableType[] = [
        {
            key: Common.EVSOLUTION_B2_BAT_PACK_VOLT_KEY,
            name: Common.EVSOLUTION_B2_BAT_PACK_VOLT_NAME,
            value: getBms321BatPackVoltValue(),
        },
        {
            key: Common.EVSOLUTION_B2_BMS_MODE_KEY,
            name: Common.EVSOLUTION_B2_BMS_MODE_NAME,
            value: getBms321BmsModeValue(),
        },
        {
            key: Common.EVSOLUTION_B2_WATER_PUMP_STATUS_KEY,
            name: Common.EVSOLUTION_B2_WATER_PUMP_STATUS_NAME,
            value: getBms321WaterPumpStatusValue(),
        },
        {
            key: Common.EVSOLUTION_B2_BALANCING_STATUS_KEY,
            name: Common.EVSOLUTION_B2_BALANCING_STATUS_NAME,
            value: getBms321BalancingStatusValue(),
        },
        {
            key: Common.EVSOLUTION_B2_BAT_PACK_ASOC_KEY,
            name: Common.EVSOLUTION_B2_BAT_PACK_ASOC_NAME,
            value: getBms321BatPackAsocValue(),
        },

        {
            key: Common.EVSOLUTION_B2_BAT_PACK_RSOC_KEY,
            name: Common.EVSOLUTION_B2_BAT_PACK_RSOC_NAME,
            value: getBms321BatPackRsocValue(),
        },
        {
            key: Common.EVSOLUTION_B2_BAT_PACK_SOH_KEY,
            name: Common.EVSOLUTION_B2_BAT_PACK_SOH_NAME,
            value: getBms321BatPackSohValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Bms322
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bms322PanelOpen, setBms322PanelOpen] = useState(false);
    const [bms322ChartMounted, setBms322ChartMounted] = useState(false);
    const [selectedBms322, setSelectedBms322] = useState<Array<React.Key>>([]);

    const [seriesChartDatasBms322, setSeriesChartDatasBms322] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBms322BatMinCellVolt, setChartBms322BatMinCellVolt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B3_BAT_MIN_CELL_VOLT_NAME,
        data: [],
    });

    const [chartBms322BatMaxCellVolt, setChartBms322BatMaxCellVolt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B3_BAT_MAX_CELL_VOLT_NAME,
        data: [],
    });

    const [chartBms322BatAvgCellVolt, setChartBms322BatAvgCellVolt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B3_BAT_AVG_CELL_VOLT_NAME,
        data: [],
    });

    const [chartBms322BatSumVolt, setChartBms322BatSumVolt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B3_BAT_SUM_VOLT_NAME,
        data: [],
    });

    const getBms322BatMinCellVoltValue = () => {
        if (selectedBms322.includes(Common.EVSOLUTION_B3_BAT_MIN_CELL_VOLT_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms322?.batMinCellVolt);
        }
        return "-";
    };

    const getBms322BatMaxCellVoltValue = () => {
        if (selectedBms322.includes(Common.EVSOLUTION_B3_BAT_MAX_CELL_VOLT_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms322?.batMaxCellVolt);
        }
        return "-";
    };

    const getBms322BatAvgCellVoltValue = () => {
        if (selectedBms322.includes(Common.EVSOLUTION_B3_BAT_AVG_CELL_VOLT_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms322?.batAvgCellVolt);
        }
        return "-";
    };

    const getBms322BatSumVoltValue = () => {
        if (selectedBms322.includes(Common.EVSOLUTION_B3_BAT_SUM_VOLT_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms322?.batSumVolt);
        }
        return "-";
    };

    const onChangeBms322 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBms322(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBms322: Array<TypeUtils.ChartData> = [];

        if (selectedBms322.includes(Common.EVSOLUTION_B3_BAT_MIN_CELL_VOLT_KEY)) chartDatasBms322.push(chartBms322BatMinCellVolt);
        if (selectedBms322.includes(Common.EVSOLUTION_B3_BAT_MAX_CELL_VOLT_KEY)) chartDatasBms322.push(chartBms322BatMaxCellVolt);
        if (selectedBms322.includes(Common.EVSOLUTION_B3_BAT_AVG_CELL_VOLT_KEY)) chartDatasBms322.push(chartBms322BatAvgCellVolt);
        if (selectedBms322.includes(Common.EVSOLUTION_B3_BAT_SUM_VOLT_KEY)) chartDatasBms322.push(chartBms322BatSumVolt);

        setSeriesChartDatasBms322(chartDatasBms322);
    }, [selectedBms322, chartBms322BatMinCellVolt, chartBms322BatMaxCellVolt, chartBms322BatAvgCellVolt, chartBms322BatSumVolt]);

    const tableDataBms322: CanTableType[] = [
        {
            key: Common.EVSOLUTION_B3_BAT_MIN_CELL_VOLT_KEY,
            name: Common.EVSOLUTION_B3_BAT_MIN_CELL_VOLT_NAME,
            value: getBms322BatMinCellVoltValue(),
        },
        {
            key: Common.EVSOLUTION_B3_BAT_MAX_CELL_VOLT_KEY,
            name: Common.EVSOLUTION_B3_BAT_MAX_CELL_VOLT_NAME,
            value: getBms322BatMaxCellVoltValue(),
        },
        {
            key: Common.EVSOLUTION_B3_BAT_AVG_CELL_VOLT_KEY,
            name: Common.EVSOLUTION_B3_BAT_AVG_CELL_VOLT_NAME,
            value: getBms322BatAvgCellVoltValue(),
        },
        {
            key: Common.EVSOLUTION_B3_BAT_SUM_VOLT_KEY,
            name: Common.EVSOLUTION_B3_BAT_SUM_VOLT_NAME,
            value: getBms322BatSumVoltValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Bms323
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bms323PanelOpen, setBms323PanelOpen] = useState(false);
    const [bms323ChartMounted, setBms323ChartMounted] = useState(false);
    const [selectedBms323, setSelectedBms323] = useState<Array<React.Key>>([]);

    const [seriesChartDatasBms323, setSeriesChartDatasBms323] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBms323BatMinTemp, setChartBms323BatMinTemp] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_BAT_MIN_TEMP_NAME,
        data: [],
    });

    const [chartBms323BatMaxTemp, setChartBms323BatMaxTemp] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_BAT_MAX_TEMP_NAME,
        data: [],
    });

    const [chartBms323BatAvgTemp, setChartBms323BatAvgTemp] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_BAT_AVG_TEMP_NAME,
        data: [],
    });

    const [chartBms323BatMinTempLocation, setChartBms323BatMinTempLocation] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_BAT_MIN_TEMP_LOCATION_NAME,
        data: [],
    });

    const [chartBms323BatMaxTempLocation, setChartBms323BatMaxTempLocation] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_BAT_MAX_TEMP_LOCATION_NAME,
        data: [],
    });

    const [chartBms323CoolingPumpFeedbackStatus, setChartBms323CoolingPumpFeedbackStatus] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_COOLING_PUMP_FEEDBACK_STATUS_NAME,
        data: [],
    });

    const [chartBms323CoolingRequest, setChartBms323CoolingRequest] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_COOLING_REQUEST_NAME,
        data: [],
    });

    const [chartBms323ChargingStop, setChartBms323ChargingStop] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_CHARGING_STOP_NAME,
        data: [],
    });

    const [chartBms323BhcStsOwTs, setChartBms323BhcStsOwTs] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_BHC_STS_OW_TS_NAME,
        data: [],
    });

    const [chartBms323BhcStsWhuWtO, setChartBms323BhcStsWhuWtO] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_BHC_STS_WHU_WT_O_NAME,
        data: [],
    });

    const [chartBms323BhcStsErr, setChartBms323BhcStsErr] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_BHC_STS_ERR_NAME,
        data: [],
    });

    const [chartBms323AuxBattery, setChartBms323AuxBattery] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B4_AUX_BATTERY_NAME,
        data: [],
    });

    const getBms323BatMinTempValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_MIN_TEMP_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms323?.batMinTemp);
        }
        return "-";
    };

    const getBms323BatMaxTempValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_MAX_TEMP_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms323?.batMaxTemp);
        }
        return "-";
    };

    const getBms323BatAvgTempValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_AVG_TEMP_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms323?.batAvgTemp);
        }
        return "-";
    };

    const getBms323BatMinTempLocationValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_MIN_TEMP_LOCATION_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms323?.batMinTempLocation);
        }
        return "-";
    };

    const getBms323BatMaxTempLocationValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_MAX_TEMP_LOCATION_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms323?.batMaxTempLocation);
        }
        return "-";
    };

    const getBms323CoolingPumpFeedbackStatusValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_COOLING_PUMP_FEEDBACK_STATUS_KEY) && currentCanData !== undefined) {
            return convertRemarkCoolingPumpFeedbackStatus(currentCanData.bms323?.coolingPumpFeedbackStatus);
        }
        return "-";
    };

    const getBms323CoolingRequestValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_COOLING_REQUEST_KEY) && currentCanData !== undefined) {
            return convertRemarkRequest(currentCanData.bms323?.coolingRequest);
        }
        return "-";
    };

    const getBms323ChargingStopValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_CHARGING_STOP_KEY) && currentCanData !== undefined) {
            return convertRemarkRequest(currentCanData.bms323?.chargingStop);
        }
        return "-";
    };

    const getBms323BhcStsOwTsValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BHC_STS_OW_TS_KEY) && currentCanData !== undefined) {
            return convertRemarkBhcStsOwTs(currentCanData.bms323?.bhcStsOwTs);
        }
        return "-";
    };

    const getBms323BhcStsWhuWtOValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BHC_STS_WHU_WT_O_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms323?.bhcStsWhuWtO);
        }
        return "-";
    };

    const getBms323BhcStsErrValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BHC_STS_ERR_KEY) && currentCanData !== undefined) {
            return convertRemarkBhcStsErr(currentCanData.bms323?.bhcStsErr);
        }
        return "-";
    };

    const getBms323AuxBatteryValue = () => {
        if (selectedBms323.includes(Common.EVSOLUTION_B4_AUX_BATTERY_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms323?.auxBattery);
        }
        return "-";
    };

    const onChangeBms323 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBms323(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBms323: Array<TypeUtils.ChartData> = [];

        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_MIN_TEMP_KEY)) chartDatasBms323.push(chartBms323BatMinTemp);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_MAX_TEMP_KEY)) chartDatasBms323.push(chartBms323BatMaxTemp);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_AVG_TEMP_KEY)) chartDatasBms323.push(chartBms323BatAvgTemp);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_MIN_TEMP_LOCATION_KEY)) chartDatasBms323.push(chartBms323BatMinTempLocation);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BAT_MAX_TEMP_LOCATION_KEY)) chartDatasBms323.push(chartBms323BatMaxTempLocation);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_COOLING_PUMP_FEEDBACK_STATUS_KEY))
            chartDatasBms323.push(chartBms323CoolingPumpFeedbackStatus);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_COOLING_REQUEST_KEY)) chartDatasBms323.push(chartBms323CoolingRequest);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_CHARGING_STOP_KEY)) chartDatasBms323.push(chartBms323ChargingStop);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BHC_STS_OW_TS_KEY)) chartDatasBms323.push(chartBms323BhcStsOwTs);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BHC_STS_WHU_WT_O_KEY)) chartDatasBms323.push(chartBms323BhcStsWhuWtO);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_BHC_STS_ERR_KEY)) chartDatasBms323.push(chartBms323BhcStsErr);
        if (selectedBms323.includes(Common.EVSOLUTION_B4_AUX_BATTERY_KEY)) chartDatasBms323.push(chartBms323AuxBattery);

        setSeriesChartDatasBms323(chartDatasBms323);
    }, [
        selectedBms323,
        chartBms323BatMinTemp,
        chartBms323BatMaxTemp,
        chartBms323BatAvgTemp,
        chartBms323BatMinTempLocation,
        chartBms323BatMaxTempLocation,
        chartBms323CoolingPumpFeedbackStatus,
        chartBms323CoolingRequest,
        chartBms323ChargingStop,
        chartBms323BhcStsOwTs,
        chartBms323BhcStsWhuWtO,
        chartBms323BhcStsErr,
        chartBms323AuxBattery,
    ]);

    const tableDataBms323: CanTableType[] = [
        {
            key: Common.EVSOLUTION_B4_BAT_MIN_TEMP_KEY,
            name: Common.EVSOLUTION_B4_BAT_MIN_TEMP_NAME,
            value: getBms323BatMinTempValue(),
        },
        {
            key: Common.EVSOLUTION_B4_BAT_MAX_TEMP_KEY,
            name: Common.EVSOLUTION_B4_BAT_MAX_TEMP_NAME,
            value: getBms323BatMaxTempValue(),
        },
        {
            key: Common.EVSOLUTION_B4_BAT_AVG_TEMP_KEY,
            name: Common.EVSOLUTION_B4_BAT_AVG_TEMP_NAME,
            value: getBms323BatAvgTempValue(),
        },
        {
            key: Common.EVSOLUTION_B4_BAT_MIN_TEMP_LOCATION_KEY,
            name: Common.EVSOLUTION_B4_BAT_MIN_TEMP_LOCATION_NAME,
            value: getBms323BatMinTempLocationValue(),
        },
        {
            key: Common.EVSOLUTION_B4_BAT_MAX_TEMP_LOCATION_KEY,
            name: Common.EVSOLUTION_B4_BAT_MAX_TEMP_LOCATION_NAME,
            value: getBms323BatMaxTempLocationValue(),
        },

        {
            key: Common.EVSOLUTION_B4_COOLING_PUMP_FEEDBACK_STATUS_KEY,
            name: Common.EVSOLUTION_B4_COOLING_PUMP_FEEDBACK_STATUS_NAME,
            value: getBms323CoolingPumpFeedbackStatusValue(),
        },
        {
            key: Common.EVSOLUTION_B4_COOLING_REQUEST_KEY,
            name: Common.EVSOLUTION_B4_COOLING_REQUEST_NAME,
            value: getBms323CoolingRequestValue(),
        },
        {
            key: Common.EVSOLUTION_B4_CHARGING_STOP_KEY,
            name: Common.EVSOLUTION_B4_CHARGING_STOP_NAME,
            value: getBms323ChargingStopValue(),
        },
        {
            key: Common.EVSOLUTION_B4_BHC_STS_OW_TS_KEY,
            name: Common.EVSOLUTION_B4_BHC_STS_OW_TS_NAME,
            value: getBms323BhcStsOwTsValue(),
        },
        {
            key: Common.EVSOLUTION_B4_BHC_STS_WHU_WT_O_KEY,
            name: Common.EVSOLUTION_B4_BHC_STS_WHU_WT_O_NAME,
            value: getBms323BhcStsWhuWtOValue(),
        },
        {
            key: Common.EVSOLUTION_B4_BHC_STS_ERR_KEY,
            name: Common.EVSOLUTION_B4_BHC_STS_ERR_NAME,
            value: getBms323BhcStsErrValue(),
        },
        {
            key: Common.EVSOLUTION_B4_AUX_BATTERY_KEY,
            name: Common.EVSOLUTION_B4_AUX_BATTERY_NAME,
            value: getBms323AuxBatteryValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Bms324
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bms324PanelOpen, setBms324PanelOpen] = useState(false);
    const [bms324ChartMounted, setBms324ChartMounted] = useState(false);
    const [selectedBms324, setSelectedBms324] = useState<Array<React.Key>>([]);

    const [seriesChartDatasBms324, setSeriesChartDatasBms324] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBms324ChargePowerAvailable2, setChartBms324ChargePowerAvailable2] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_2_NAME,
        data: [],
    });

    const [chartBms324DischargePowerAvailable2, setChartBms324DischargePowerAvailable2] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_2_NAME,
        data: [],
    });

    const [chartBms324ChargePowerAvailable10, setChartBms324ChargePowerAvailable10] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_10_NAME,
        data: [],
    });

    const [chartBms324DischargePowerAvailable10, setChartBms324DischargePowerAvailable10] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_10_NAME,
        data: [],
    });

    const [chartBms324BatPackSoe, setChartBms324BatPackSoe] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B5_BAT_PACK_SOE_NAME,
        data: [],
    });

    const getBms324ChargePowerAvailable2Value = () => {
        if (selectedBms324.includes(Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_2_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms324?.chargePowerAvailable2);
        }
        return "-";
    };

    const getBms324DischargePowerAvailable2Value = () => {
        if (selectedBms324.includes(Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_2_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms324?.dischargePowerAvailable2);
        }
        return "-";
    };

    const getBms324ChargePowerAvailable10Value = () => {
        if (selectedBms324.includes(Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_10_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms324?.chargePowerAvailable10);
        }
        return "-";
    };

    const getBms324DischargePowerAvailable10Value = () => {
        if (selectedBms324.includes(Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_10_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms324?.dischargePowerAvailable10);
        }
        return "-";
    };

    const getBms324BatPackSoeValue = () => {
        if (selectedBms324.includes(Common.EVSOLUTION_B5_BAT_PACK_SOE_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms324?.batPackSoe);
        }
        return "-";
    };

    const onChangeBms324 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBms324(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBms324: Array<TypeUtils.ChartData> = [];

        if (selectedBms324.includes(Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_2_KEY)) chartDatasBms324.push(chartBms324ChargePowerAvailable2);
        if (selectedBms324.includes(Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_2_KEY)) chartDatasBms324.push(chartBms324DischargePowerAvailable2);
        if (selectedBms324.includes(Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_10_KEY)) chartDatasBms324.push(chartBms324ChargePowerAvailable10);
        if (selectedBms324.includes(Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_10_KEY))
            chartDatasBms324.push(chartBms324DischargePowerAvailable10);
        if (selectedBms324.includes(Common.EVSOLUTION_B5_BAT_PACK_SOE_KEY)) chartDatasBms324.push(chartBms324BatPackSoe);

        setSeriesChartDatasBms324(chartDatasBms324);
    }, [
        selectedBms324,
        chartBms324ChargePowerAvailable2,
        chartBms324DischargePowerAvailable2,
        chartBms324ChargePowerAvailable10,
        chartBms324DischargePowerAvailable10,
        chartBms324BatPackSoe,
    ]);

    const tableDataBms324: CanTableType[] = [
        {
            key: Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_2_KEY,
            name: Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_2_NAME,
            value: getBms324ChargePowerAvailable2Value(),
        },
        {
            key: Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_2_KEY,
            name: Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_2_NAME,
            value: getBms324DischargePowerAvailable2Value(),
        },
        {
            key: Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_10_KEY,
            name: Common.EVSOLUTION_B5_CHARGE_POWER_AVAILABLE_10_NAME,
            value: getBms324ChargePowerAvailable10Value(),
        },
        {
            key: Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_10_KEY,
            name: Common.EVSOLUTION_B5_DISCHARGE_POWER_AVAILABLE_10_NAME,
            value: getBms324DischargePowerAvailable10Value(),
        },
        {
            key: Common.EVSOLUTION_B5_BAT_PACK_SOE_KEY,
            name: Common.EVSOLUTION_B5_BAT_PACK_SOE_NAME,
            value: getBms324BatPackSoeValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Bms325
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bms325PanelOpen, setBms325PanelOpen] = useState(false);
    const [bms325ChartMounted, setBms325ChartMounted] = useState(false);
    const [selectedBms325, setSelectedBms325] = useState<Array<React.Key>>([]);

    const [seriesChartDatasBms325, setSeriesChartDatasBms325] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBms325ChargeCurrLimit, setChartBms325ChargeCurrLimit] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B6_CHARGE_CURR_LIMIT_NAME,
        data: [],
    });

    const [chartBms325ChargeVoltLimit, setChartBms325ChargeVoltLimit] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B6_CHARGE_VOLT_LIMIT_NAME,
        data: [],
    });

    const [chartBms325InstantPowerConsumption, setChartBms325InstantPowerConsumption] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B6_INSTANT_POWER_CONSUMPTION_NAME,
        data: [],
    });

    const [chartBms325MinIsolationResistance, setChartBms325MinIsolationResistance] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_B6_MIN_ISOLATION_RESISTANCE_NAME,
        data: [],
    });

    const getBms325ChargeCurrLimitValue = () => {
        if (selectedBms325.includes(Common.EVSOLUTION_B6_CHARGE_CURR_LIMIT_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms325?.chargeCurrLimit);
        }
        return "-";
    };

    const getBms325ChargeVoltLimitValue = () => {
        if (selectedBms325.includes(Common.EVSOLUTION_B6_CHARGE_VOLT_LIMIT_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms325?.chargeVoltLimit);
        }
        return "-";
    };

    const getBms325InstantPowerConsumptionValue = () => {
        if (selectedBms325.includes(Common.EVSOLUTION_B6_INSTANT_POWER_CONSUMPTION_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms325?.instantPowerConsumption);
        }
        return "-";
    };

    const getBms325MinIsolationResistanceValue = () => {
        if (selectedBms325.includes(Common.EVSOLUTION_B6_MIN_ISOLATION_RESISTANCE_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms325?.minIsolationResistance);
        }
        return "-";
    };

    const onChangeBms325 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBms325(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBms325: Array<TypeUtils.ChartData> = [];

        if (selectedBms325.includes(Common.EVSOLUTION_B6_CHARGE_CURR_LIMIT_KEY)) chartDatasBms325.push(chartBms325ChargeCurrLimit);
        if (selectedBms325.includes(Common.EVSOLUTION_B6_CHARGE_VOLT_LIMIT_KEY)) chartDatasBms325.push(chartBms325ChargeVoltLimit);
        if (selectedBms325.includes(Common.EVSOLUTION_B6_INSTANT_POWER_CONSUMPTION_KEY)) chartDatasBms325.push(chartBms325InstantPowerConsumption);
        if (selectedBms325.includes(Common.EVSOLUTION_B6_MIN_ISOLATION_RESISTANCE_KEY)) chartDatasBms325.push(chartBms325MinIsolationResistance);

        setSeriesChartDatasBms325(chartDatasBms325);
    }, [
        selectedBms325,
        chartBms325ChargeCurrLimit,
        chartBms325ChargeVoltLimit,
        chartBms325InstantPowerConsumption,
        chartBms325MinIsolationResistance,
    ]);

    const tableDataBms325: CanTableType[] = [
        {
            key: Common.EVSOLUTION_B6_CHARGE_CURR_LIMIT_KEY,
            name: Common.EVSOLUTION_B6_CHARGE_CURR_LIMIT_NAME,
            value: getBms325ChargeCurrLimitValue(),
        },
        {
            key: Common.EVSOLUTION_B6_CHARGE_VOLT_LIMIT_KEY,
            name: Common.EVSOLUTION_B6_CHARGE_VOLT_LIMIT_NAME,
            value: getBms325ChargeVoltLimitValue(),
        },
        {
            key: Common.EVSOLUTION_B6_INSTANT_POWER_CONSUMPTION_KEY,
            name: Common.EVSOLUTION_B6_INSTANT_POWER_CONSUMPTION_NAME,
            value: getBms325InstantPowerConsumptionValue(),
        },
        {
            key: Common.EVSOLUTION_B6_MIN_ISOLATION_RESISTANCE_KEY,
            name: Common.EVSOLUTION_B6_MIN_ISOLATION_RESISTANCE_NAME,
            value: getBms325MinIsolationResistanceValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Bms326
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bms326PanelOpen, setBms326PanelOpen] = useState(false);
    const [bms326ChartMounted, setBms326ChartMounted] = useState(false);
    const [selectedBms326, setSelectedBms326] = useState<Array<React.Key>>([]);

    const [seriesChartDatasBms326, setSeriesChartDatasBms326] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBms326HwVer, setChartBms326HwVer] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_HW_VER_NAME,
        data: [],
    });

    const [chartBms326SwVer, setChartBms326SwVer] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_SW_VER_NAME,
        data: [],
    });

    const [chartBms326BootVer, setChartBms326BootVer] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_BOOT_VER_NAME,
        data: [],
    });

    const [chartBms326IntFlt, setChartBms326IntFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_INT_FLT_NAME,
        data: [],
    });

    const [chartBms326CmiFltInit, setChartBms326CmiFltInit] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CMI_FLT_INIT_NAME,
        data: [],
    });

    const [chartBms326CmiFlt, setChartBms326CmiFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CMI_FLT_NAME,
        data: [],
    });

    const [chartBms326FetFlt, setChartBms326FetFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_FET_FLT_NAME,
        data: [],
    });

    const [chartBms326RlyMnCs, setChartBms326RlyMnCs] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_RLY_MN_CS_NAME,
        data: [],
    });

    const [chartBms326RlyMpCs, setChartBms326RlyMpCs] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_RLY_MP_CS_NAME,
        data: [],
    });

    const [chartBms326ItempSh, setChartBms326ItempSh] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_I_TEMP_SH_NAME,
        data: [],
    });

    const [chartBms326ItempSl, setChartBms326ItempSl] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_I_TEMP_SL_NAME,
        data: [],
    });

    const [chartBms326IsoFlt, setChartBms326IsoFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_ISO_FLT_NAME,
        data: [],
    });

    const [chartBms326CrashOpn, setChartBms326CrashOpn] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CRASH_OPN_NAME,
        data: [],
    });

    const [chartBms326CrashHw, setChartBms326CrashHw] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CRASH_HW_NAME,
        data: [],
    });

    const [chartBms326CrashCan, setChartBms326CrashCan] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CRASH_CAN_NAME,
        data: [],
    });

    const [chartBms326VcuLcm, setChartBms326VcuLcm] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_VCU_LCM_NAME,
        data: [],
    });

    const [chartBms326CrtSensWan, setChartBms326CrtSensWan] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CRT_SENS_WAN_NAME,
        data: [],
    });

    const [chartBms326CrtSensDev, setChartBms326CrtSensDev] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CRT_SENS_DEV_NAME,
        data: [],
    });

    const [chartBms326EcanBusOff, setChartBms326EcanBusOff] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_ECAN_BUS_OFF_NAME,
        data: [],
    });

    const [chartBms326PcanBusOff, setChartBms326PcanBusOff] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_PCAN_BUS_OFF_NAME,
        data: [],
    });

    const [chartBms326HeaterFlt, setChartBms326HeaterFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_HEATER_FLT_NAME,
        data: [],
    });

    const [chartBms326RlyMnCos, setChartBms326RlyMnCos] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_RLY_MN_COS_NAME,
        data: [],
    });

    const [chartBms326RlyMpCos, setChartBms326RlyMpCos] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_RLY_MP_COS_NAME,
        data: [],
    });

    const [chartBms326RlyPcCos, setChartBms326RlyPcCos] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_RLY_PC_COS_NAME,
        data: [],
    });

    const [chartBms326RlyMnCcs, setChartBms326RlyMnCcs] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_RLY_MN_CCS_NAME,
        data: [],
    });

    const [chartBms326RlyMpCcs, setChartBms326RlyMpCcs] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_RLY_MP_CCS_NAME,
        data: [],
    });

    const [chartBms326RlyPcCcs, setChartBms326RlyPcCcs] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_RLY_PC_CCS_NAME,
        data: [],
    });

    const [chartBms326CrashNr, setChartBms326CrashNr] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CRASH_NR_NAME,
        data: [],
    });

    const [chartBms326CtempFltAll, setChartBms326CtempFltAll] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_C_TEMP_FLT_ALL_NAME,
        data: [],
    });

    const [chartBms326CellOpn, setChartBms326CellOpn] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CELL_OPN_NAME,
        data: [],
    });

    const [chartBms326CtempFlt, setChartBms326CtempFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_C_TEMP_FLT_NAME,
        data: [],
    });

    const [chartBms326CvHFlt, setChartBms326CvHFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CV_H_FLT_NAME,
        data: [],
    });

    const [chartBms326CvLFlt, setChartBms326CvLFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CV_L_FLT_NAME,
        data: [],
    });

    const [chartBms326CvHWan, setChartBms326CvHWan] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CV_H_WAN_NAME,
        data: [],
    });

    const [chartBms326CvLWan, setChartBms326CvLWan] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CV_L_WAN_NAME,
        data: [],
    });

    const [chartBms326CvDevOcvFlt, setChartBms326CvDevOcvFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CV_DEV_OCV_FLT_NAME,
        data: [],
    });

    const [chartBms326CvDevFlt, setChartBms326CvDevFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CV_DEV_FLT_NAME,
        data: [],
    });

    const [chartBms326PvHFlt, setChartBms326PvHFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_PV_H_FLT_NAME,
        data: [],
    });

    const [chartBms326PvLFlt, setChartBms326PvLFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_PV_L_FLT_NAME,
        data: [],
    });

    const [chartBms326PvHWan, setChartBms326PvHWan] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_PV_H_WAN_NAME,
        data: [],
    });

    const [chartBms326PvLWan, setChartBms326PvLWan] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_PV_L_WAN_NAME,
        data: [],
    });

    const [chartBms326CtHFlt, setChartBms326CtHFlt] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CT_H_FLT_NAME,
        data: [],
    });

    const [chartBms326CtHWan, setChartBms326CtHWan] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_BF_CT_H_WAN_NAME,
        data: [],
    });

    const getBms326HwVerValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_HW_VER_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms326?.hwVer);
        }
        return "-";
    };

    const getBms326SwVerValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_SW_VER_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms326?.swVer);
        }
        return "-";
    };

    const getBms326BootVerValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_BOOT_VER_KEY) && currentCanData !== undefined) {
            return String(currentCanData.bms326?.bootVer);
        }
        return "-";
    };

    const getBms326IntFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_INT_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.intFlt);
        }
        return "-";
    };

    const getBms326CmiFltInitValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CMI_FLT_INIT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cmiFltInit);
        }
        return "-";
    };

    const getBms326CmiFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CMI_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cmiFlt);
        }
        return "-";
    };

    const getBms326FetFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_FET_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.fetFlt);
        }
        return "-";
    };

    const getBms326RlyMnCsValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MN_CS_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.rlyMnCs);
        }
        return "-";
    };

    const getBms326RlyMpCsValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MP_CS_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.rlyMpCs);
        }
        return "-";
    };

    const getBms326ItempShValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_I_TEMP_SH_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.itempSh);
        }
        return "-";
    };

    const getBms326ItempSlValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_I_TEMP_SL_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.itempSl);
        }
        return "-";
    };

    const getBms326IsoFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_ISO_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.isoFlt);
        }
        return "-";
    };

    const getBms326CrashOpnValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRASH_OPN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.crashOpn);
        }
        return "-";
    };

    const getBms326CrashHwValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRASH_HW_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.crashHw);
        }
        return "-";
    };

    const getBms326CrashCanValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRASH_CAN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.crashCan);
        }
        return "-";
    };

    const getBms326VcuLcmValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_VCU_LCM_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.vcuLcm);
        }
        return "-";
    };

    const getBms326CrtSensWanValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRT_SENS_WAN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.crtSensWan);
        }
        return "-";
    };

    const getBms326CrtSensDevValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRT_SENS_DEV_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.crtSensDev);
        }
        return "-";
    };

    const getBms326EcanBusOffValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_ECAN_BUS_OFF_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.ecanBusOff);
        }
        return "-";
    };

    const getBms326PcanBusOffValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PCAN_BUS_OFF_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.pcanBusOff);
        }
        return "-";
    };

    const getBms326HeaterFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_HEATER_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.heaterFlt);
        }
        return "-";
    };

    const getBms326RlyMnCosValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MN_COS_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.rlyMnCos);
        }
        return "-";
    };

    const getBms326RlyMpCosValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MP_COS_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.rlyMpCos);
        }
        return "-";
    };

    const getBms326RlyPcCosValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_PC_COS_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.rlyPcCos);
        }
        return "-";
    };

    const getBms326RlyMnCcsValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MN_CCS_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.rlyMnCcs);
        }
        return "-";
    };

    const getBms326RlyMpCcsValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MP_CCS_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.rlyMpCcs);
        }
        return "-";
    };

    const getBms326RlyPcCcsValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_PC_CCS_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.rlyPcCcs);
        }
        return "-";
    };

    const getBms326CrashNrValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRASH_NR_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.crashNr);
        }
        return "-";
    };

    const getBms326CtempFltAllValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_C_TEMP_FLT_ALL_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.ctempFltAll);
        }
        return "-";
    };

    const getBms326CellOpnValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CELL_OPN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cellOpn);
        }
        return "-";
    };

    const getBms326CtempFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_C_TEMP_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.ctempFlt);
        }
        return "-";
    };

    const getBms326CvHFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_H_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cvHFlt);
        }
        return "-";
    };

    const getBms326CvLFlValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_L_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cvLFlt);
        }
        return "-";
    };

    const getBms326CvHWanValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_H_WAN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cvHWan);
        }
        return "-";
    };

    const getBms326CvLWanValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_L_WAN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cvLWan);
        }
        return "-";
    };

    const getBms326CvDevOcvFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_DEV_OCV_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cvDevOcvFlt);
        }
        return "-";
    };

    const getBms326CvDevFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_DEV_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.cvDevFlt);
        }
        return "-";
    };

    const getBms326PvHFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PV_H_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.pvHFlt);
        }
        return "-";
    };

    const getBms326PvLFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PV_L_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.pvLFlt);
        }
        return "-";
    };

    const getBms326PvHWanValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PV_H_WAN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.pvHWan);
        }
        return "-";
    };

    const getBms326PvLWanValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PV_L_WAN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.pvLWan);
        }
        return "-";
    };

    const getBms326CtHFltValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CT_H_FLT_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.ctHFlt);
        }
        return "-";
    };

    const getBms326CtHWanValue = () => {
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CT_H_WAN_KEY) && currentCanData !== undefined) {
            return convertRemarkError(currentCanData.bms326?.ctHWan);
        }
        return "-";
    };

    const onChangeBms326 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBms326(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBms326: Array<TypeUtils.ChartData> = [];

        if (selectedBms326.includes(Common.EVSOLUTION_BF_HW_VER_KEY)) chartDatasBms326.push(chartBms326HwVer);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_SW_VER_KEY)) chartDatasBms326.push(chartBms326SwVer);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_BOOT_VER_KEY)) chartDatasBms326.push(chartBms326BootVer);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_INT_FLT_KEY)) chartDatasBms326.push(chartBms326IntFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CMI_FLT_INIT_KEY)) chartDatasBms326.push(chartBms326CmiFltInit);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CMI_FLT_KEY)) chartDatasBms326.push(chartBms326CmiFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_FET_FLT_KEY)) chartDatasBms326.push(chartBms326FetFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MN_CS_KEY)) chartDatasBms326.push(chartBms326RlyMnCs);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MP_CS_KEY)) chartDatasBms326.push(chartBms326RlyMpCs);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_I_TEMP_SH_KEY)) chartDatasBms326.push(chartBms326ItempSh);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_I_TEMP_SL_KEY)) chartDatasBms326.push(chartBms326ItempSl);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_ISO_FLT_KEY)) chartDatasBms326.push(chartBms326IsoFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRASH_OPN_KEY)) chartDatasBms326.push(chartBms326CrashOpn);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRASH_HW_KEY)) chartDatasBms326.push(chartBms326CrashHw);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRASH_CAN_KEY)) chartDatasBms326.push(chartBms326CrashCan);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_VCU_LCM_KEY)) chartDatasBms326.push(chartBms326VcuLcm);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRT_SENS_WAN_KEY)) chartDatasBms326.push(chartBms326CrtSensWan);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRT_SENS_DEV_KEY)) chartDatasBms326.push(chartBms326CrtSensDev);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_ECAN_BUS_OFF_KEY)) chartDatasBms326.push(chartBms326EcanBusOff);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PCAN_BUS_OFF_KEY)) chartDatasBms326.push(chartBms326PcanBusOff);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_HEATER_FLT_KEY)) chartDatasBms326.push(chartBms326HeaterFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MN_COS_KEY)) chartDatasBms326.push(chartBms326RlyMnCos);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MP_COS_KEY)) chartDatasBms326.push(chartBms326RlyMpCos);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_PC_COS_KEY)) chartDatasBms326.push(chartBms326RlyPcCos);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MN_CCS_KEY)) chartDatasBms326.push(chartBms326RlyMnCcs);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_MP_CCS_KEY)) chartDatasBms326.push(chartBms326RlyMpCcs);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_RLY_PC_CCS_KEY)) chartDatasBms326.push(chartBms326RlyPcCcs);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CRASH_NR_KEY)) chartDatasBms326.push(chartBms326CrashNr);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_C_TEMP_FLT_ALL_KEY)) chartDatasBms326.push(chartBms326CtempFltAll);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CELL_OPN_KEY)) chartDatasBms326.push(chartBms326CellOpn);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_C_TEMP_FLT_KEY)) chartDatasBms326.push(chartBms326CtempFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_H_FLT_KEY)) chartDatasBms326.push(chartBms326CvHFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_L_FLT_KEY)) chartDatasBms326.push(chartBms326CvLFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_H_WAN_KEY)) chartDatasBms326.push(chartBms326CvHWan);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_L_WAN_KEY)) chartDatasBms326.push(chartBms326CvLWan);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_DEV_OCV_FLT_KEY)) chartDatasBms326.push(chartBms326CvDevOcvFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CV_DEV_FLT_KEY)) chartDatasBms326.push(chartBms326CvDevFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PV_H_FLT_KEY)) chartDatasBms326.push(chartBms326PvHFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PV_L_FLT_KEY)) chartDatasBms326.push(chartBms326PvLFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PV_H_WAN_KEY)) chartDatasBms326.push(chartBms326PvHWan);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_PV_L_WAN_KEY)) chartDatasBms326.push(chartBms326PvLWan);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CT_H_FLT_KEY)) chartDatasBms326.push(chartBms326CtHFlt);
        if (selectedBms326.includes(Common.EVSOLUTION_BF_CT_H_WAN_KEY)) chartDatasBms326.push(chartBms326CtHWan);

        setSeriesChartDatasBms326(chartDatasBms326);
    }, [
        selectedBms326,
        chartBms326HwVer,
        chartBms326SwVer,
        chartBms326BootVer,
        chartBms326IntFlt,
        chartBms326CmiFltInit,
        chartBms326CmiFlt,
        chartBms326FetFlt,
        chartBms326RlyMnCs,
        chartBms326RlyMpCs,
        chartBms326ItempSh,
        chartBms326ItempSl,
        chartBms326IsoFlt,
        chartBms326CrashOpn,
        chartBms326CrashHw,
        chartBms326CrashCan,
        chartBms326VcuLcm,
        chartBms326CrtSensWan,
        chartBms326CrtSensDev,
        chartBms326EcanBusOff,
        chartBms326PcanBusOff,
        chartBms326HeaterFlt,
        chartBms326RlyMnCos,
        chartBms326RlyMpCos,
        chartBms326RlyPcCos,
        chartBms326RlyMnCcs,
        chartBms326RlyMpCcs,
        chartBms326RlyPcCcs,
        chartBms326CrashNr,
        chartBms326CtempFltAll,
        chartBms326CellOpn,
        chartBms326CtempFlt,
        chartBms326CvHFlt,
        chartBms326CvLFlt,
        chartBms326CvHWan,
        chartBms326CvLWan,
        chartBms326CvDevOcvFlt,
        chartBms326CvDevFlt,
        chartBms326PvHFlt,
        chartBms326PvLFlt,
        chartBms326PvHWan,
        chartBms326PvLWan,
        chartBms326CtHFlt,
        chartBms326CtHWan,
    ]);

    const tableDataBms326: CanTableType[] = [
        {
            key: Common.EVSOLUTION_BF_HW_VER_KEY,
            name: Common.EVSOLUTION_BF_HW_VER_NAME,
            value: getBms326HwVerValue(),
        },
        {
            key: Common.EVSOLUTION_BF_SW_VER_KEY,
            name: Common.EVSOLUTION_BF_SW_VER_NAME,
            value: getBms326SwVerValue(),
        },
        {
            key: Common.EVSOLUTION_BF_BOOT_VER_KEY,
            name: Common.EVSOLUTION_BF_BOOT_VER_NAME,
            value: getBms326BootVerValue(),
        },
        {
            key: Common.EVSOLUTION_BF_INT_FLT_KEY,
            name: Common.EVSOLUTION_BF_INT_FLT_NAME,
            value: getBms326IntFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CMI_FLT_INIT_KEY,
            name: Common.EVSOLUTION_BF_CMI_FLT_INIT_NAME,
            value: getBms326CmiFltInitValue(),
        },

        {
            key: Common.EVSOLUTION_BF_CMI_FLT_KEY,
            name: Common.EVSOLUTION_BF_CMI_FLT_NAME,
            value: getBms326CmiFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_FET_FLT_KEY,
            name: Common.EVSOLUTION_BF_FET_FLT_NAME,
            value: getBms326FetFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_RLY_MN_CS_KEY,
            name: Common.EVSOLUTION_BF_RLY_MN_CS_NAME,
            value: getBms326RlyMnCsValue(),
        },
        {
            key: Common.EVSOLUTION_BF_RLY_MP_CS_KEY,
            name: Common.EVSOLUTION_BF_RLY_MP_CS_NAME,
            value: getBms326RlyMpCsValue(),
        },
        {
            key: Common.EVSOLUTION_BF_I_TEMP_SH_KEY,
            name: Common.EVSOLUTION_BF_I_TEMP_SH_NAME,
            value: getBms326ItempShValue(),
        },

        {
            key: Common.EVSOLUTION_BF_I_TEMP_SL_KEY,
            name: Common.EVSOLUTION_BF_I_TEMP_SL_NAME,
            value: getBms326ItempSlValue(),
        },
        {
            key: Common.EVSOLUTION_BF_ISO_FLT_KEY,
            name: Common.EVSOLUTION_BF_ISO_FLT_NAME,
            value: getBms326IsoFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CRASH_OPN_KEY,
            name: Common.EVSOLUTION_BF_CRASH_OPN_NAME,
            value: getBms326CrashOpnValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CRASH_HW_KEY,
            name: Common.EVSOLUTION_BF_CRASH_HW_NAME,
            value: getBms326CrashHwValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CRASH_CAN_KEY,
            name: Common.EVSOLUTION_BF_CRASH_CAN_NAME,
            value: getBms326CrashCanValue(),
        },
        {
            key: Common.EVSOLUTION_BF_VCU_LCM_KEY,
            name: Common.EVSOLUTION_BF_VCU_LCM_NAME,
            value: getBms326VcuLcmValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CRT_SENS_WAN_KEY,
            name: Common.EVSOLUTION_BF_CRT_SENS_WAN_NAME,
            value: getBms326CrtSensWanValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CRT_SENS_DEV_KEY,
            name: Common.EVSOLUTION_BF_CRT_SENS_DEV_NAME,
            value: getBms326CrtSensDevValue(),
        },
        {
            key: Common.EVSOLUTION_BF_ECAN_BUS_OFF_KEY,
            name: Common.EVSOLUTION_BF_ECAN_BUS_OFF_NAME,
            value: getBms326EcanBusOffValue(),
        },
        {
            key: Common.EVSOLUTION_BF_PCAN_BUS_OFF_KEY,
            name: Common.EVSOLUTION_BF_PCAN_BUS_OFF_NAME,
            value: getBms326PcanBusOffValue(),
        },

        {
            key: Common.EVSOLUTION_BF_HEATER_FLT_KEY,
            name: Common.EVSOLUTION_BF_HEATER_FLT_NAME,
            value: getBms326HeaterFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_RLY_MN_COS_KEY,
            name: Common.EVSOLUTION_BF_RLY_MN_COS_NAME,
            value: getBms326RlyMnCosValue(),
        },
        {
            key: Common.EVSOLUTION_BF_RLY_MP_COS_KEY,
            name: Common.EVSOLUTION_BF_RLY_MP_COS_NAME,
            value: getBms326RlyMpCosValue(),
        },
        {
            key: Common.EVSOLUTION_BF_RLY_PC_COS_KEY,
            name: Common.EVSOLUTION_BF_RLY_PC_COS_NAME,
            value: getBms326RlyPcCosValue(),
        },
        {
            key: Common.EVSOLUTION_BF_RLY_MN_CCS_KEY,
            name: Common.EVSOLUTION_BF_RLY_MN_CCS_NAME,
            value: getBms326RlyMnCcsValue(),
        },

        {
            key: Common.EVSOLUTION_BF_RLY_MP_CCS_KEY,
            name: Common.EVSOLUTION_BF_RLY_MP_CCS_NAME,
            value: getBms326RlyMpCcsValue(),
        },
        {
            key: Common.EVSOLUTION_BF_RLY_PC_CCS_KEY,
            name: Common.EVSOLUTION_BF_RLY_PC_CCS_NAME,
            value: getBms326RlyPcCcsValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CRASH_NR_KEY,
            name: Common.EVSOLUTION_BF_CRASH_NR_NAME,
            value: getBms326CrashNrValue(),
        },
        {
            key: Common.EVSOLUTION_BF_C_TEMP_FLT_ALL_KEY,
            name: Common.EVSOLUTION_BF_C_TEMP_FLT_ALL_NAME,
            value: getBms326CtempFltAllValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CELL_OPN_KEY,
            name: Common.EVSOLUTION_BF_CELL_OPN_NAME,
            value: getBms326CellOpnValue(),
        },
        {
            key: Common.EVSOLUTION_BF_C_TEMP_FLT_KEY,
            name: Common.EVSOLUTION_BF_C_TEMP_FLT_NAME,
            value: getBms326CtempFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CV_H_FLT_KEY,
            name: Common.EVSOLUTION_BF_CV_H_FLT_NAME,
            value: getBms326CvHFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CV_L_FLT_KEY,
            name: Common.EVSOLUTION_BF_CV_L_FLT_NAME,
            value: getBms326CvLFlValue(),
        },

        {
            key: Common.EVSOLUTION_BF_CV_H_WAN_KEY,
            name: Common.EVSOLUTION_BF_CV_H_WAN_NAME,
            value: getBms326CvHWanValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CV_L_WAN_KEY,
            name: Common.EVSOLUTION_BF_CV_L_WAN_NAME,
            value: getBms326CvLWanValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CV_DEV_OCV_FLT_KEY,
            name: Common.EVSOLUTION_BF_CV_DEV_OCV_FLT_NAME,
            value: getBms326CvDevOcvFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CV_DEV_FLT_KEY,
            name: Common.EVSOLUTION_BF_CV_DEV_FLT_NAME,
            value: getBms326CvDevFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_PV_H_FLT_KEY,
            name: Common.EVSOLUTION_BF_PV_H_FLT_NAME,
            value: getBms326PvHFltValue(),
        },

        {
            key: Common.EVSOLUTION_BF_PV_L_FLT_KEY,
            name: Common.EVSOLUTION_BF_PV_L_FLT_NAME,
            value: getBms326PvLFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_PV_H_WAN_KEY,
            name: Common.EVSOLUTION_BF_PV_H_WAN_NAME,
            value: getBms326PvHWanValue(),
        },
        {
            key: Common.EVSOLUTION_BF_PV_L_WAN_KEY,
            name: Common.EVSOLUTION_BF_PV_L_WAN_NAME,
            value: getBms326PvLWanValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CT_H_FLT_KEY,
            name: Common.EVSOLUTION_BF_CT_H_FLT_NAME,
            value: getBms326CtHFltValue(),
        },
        {
            key: Common.EVSOLUTION_BF_CT_H_WAN_KEY,
            name: Common.EVSOLUTION_BF_CT_H_WAN_NAME,
            value: getBms326CtHWanValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Mcu1E1
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [mcu1E1PanelOpen, setMcu1E1PanelOpen] = useState(false);
    const [mcu1E1ChartMounted, setMcu1E1ChartMounted] = useState(false);
    const [selectedMcu1E1, setSelectedMcu1E1] = useState<Array<React.Key>>([]);

    const [seriesChartDatasMcu1E1, setSeriesChartDatasMcu1E1] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartMcu1E1MotorTorqueEstimatedRs1, setChartMcu1E1MotorTorqueEstimatedRs1] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_RS1_NAME,
        data: [],
    });

    const [chartMcu1E1MotorTorqueEstimated, setChartMcu1E1MotorTorqueEstimated] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_NAME,
        data: [],
    });

    const [chartMcu1E1MotorSpeed, setChartMcu1E1MotorSpeed] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_M1_MOTOR_SPEED_NAME,
        data: [],
    });

    const [chartMcu1E1Counter, setChartMcu1E1Counter] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_M1_COUNTER_NAME,
        data: [],
    });

    const [chartMcu1E1Checksum, setChartMcu1E1Checksum] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_M1_CHECKSUM_NAME,
        data: [],
    });

    const getMcu1E1MotorTorqueEstimatedRs1Value = () => {
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_RS1_KEY) && currentCanData !== undefined) {
            return String(currentCanData.mcu1E1?.motorTorqueEstimatedRs1);
        }
        return "-";
    };

    const getMcu1E1MotorTorqueEstimatedValue = () => {
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_KEY) && currentCanData !== undefined) {
            return String(currentCanData.mcu1E1?.motorTorqueEstimated);
        }
        return "-";
    };

    const getMcu1E1ChargePowerAvailable10Value = () => {
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_MOTOR_SPEED_KEY) && currentCanData !== undefined) {
            return String(currentCanData.mcu1E1?.motorSpeed);
        }
        return "-";
    };

    const getMcu1E1CounterValue = () => {
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_COUNTER_KEY) && currentCanData !== undefined) {
            return String(currentCanData.mcu1E1?.counter);
        }
        return "-";
    };

    const getMcu1E1ChecksumValue = () => {
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_CHECKSUM_KEY) && currentCanData !== undefined) {
            return String(currentCanData.mcu1E1?.checksum);
        }
        return "-";
    };

    const onChangeMcu1E1 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedMcu1E1(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasMcu1E1: Array<TypeUtils.ChartData> = [];

        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_RS1_KEY)) chartDatasMcu1E1.push(chartMcu1E1MotorTorqueEstimatedRs1);
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_KEY)) chartDatasMcu1E1.push(chartMcu1E1MotorTorqueEstimated);
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_MOTOR_SPEED_KEY)) chartDatasMcu1E1.push(chartMcu1E1MotorSpeed);
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_COUNTER_KEY)) chartDatasMcu1E1.push(chartMcu1E1Counter);
        if (selectedMcu1E1.includes(Common.EVSOLUTION_M1_CHECKSUM_KEY)) chartDatasMcu1E1.push(chartMcu1E1Checksum);

        setSeriesChartDatasMcu1E1(chartDatasMcu1E1);
    }, [
        selectedMcu1E1,
        chartMcu1E1MotorTorqueEstimatedRs1,
        chartMcu1E1MotorTorqueEstimated,
        chartMcu1E1MotorSpeed,
        chartMcu1E1Counter,
        chartMcu1E1Checksum,
    ]);

    const tableDataMcu1E1: CanTableType[] = [
        {
            key: Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_RS1_KEY,
            name: Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_RS1_NAME,
            value: getMcu1E1MotorTorqueEstimatedRs1Value(),
        },
        {
            key: Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_KEY,
            name: Common.EVSOLUTION_M1_MOTOR_TORQUE_ESTIMATED_NAME,
            value: getMcu1E1MotorTorqueEstimatedValue(),
        },
        {
            key: Common.EVSOLUTION_M1_MOTOR_SPEED_KEY,
            name: Common.EVSOLUTION_M1_MOTOR_SPEED_NAME,
            value: getMcu1E1ChargePowerAvailable10Value(),
        },
        {
            key: Common.EVSOLUTION_M1_COUNTER_KEY,
            name: Common.EVSOLUTION_M1_COUNTER_NAME,
            value: getMcu1E1CounterValue(),
        },
        {
            key: Common.EVSOLUTION_M1_CHECKSUM_KEY,
            name: Common.EVSOLUTION_M1_CHECKSUM_NAME,
            value: getMcu1E1ChecksumValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Vcu1D4
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu1D4PanelOpen, setVcu1D4PanelOpen] = useState(false);
    const [vcu1D4ChartMounted, setVcu1D4ChartMounted] = useState(false);
    const [selectedVcu1D4, setSelectedVcu1D4] = useState<Array<React.Key>>([]);

    const [seriesChartDatasVcu1D4, setSeriesChartDatasVcu1D4] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu1D4MainContactorControl, setChartVcu1D4MainContactorControl] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V1_MAIN_CONTACTOR_CONTROL_NAME,
        data: [],
    });

    const [chartVcu1D4IsoltMtrStpReq, setChartVcu1D4IsoltMtrStpReq] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V1_ISOLT_MTR_STP_REQ_NAME,
        data: [],
    });

    const [chartVcu1D4Counter, setChartVcu1D4Counter] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V1_COUNTER_NAME,
        data: [],
    });

    const [chartVcu1D4Checksum, setChartVcu1D4Checksum] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V1_CHECKSUM_NAME,
        data: [],
    });

    const getVcu1D4MainContactorControlValue = () => {
        if (selectedVcu1D4.includes(Common.EVSOLUTION_V1_MAIN_CONTACTOR_CONTROL_KEY) && currentCanData !== undefined) {
            return convertRemarkContactorCoilState(currentCanData.vcu1D4?.mainContactorControl);
        }
        return "-";
    };

    const getVcu1D4IsoltMtrStpReqValue = () => {
        if (selectedVcu1D4.includes(Common.EVSOLUTION_V1_ISOLT_MTR_STP_REQ_KEY) && currentCanData !== undefined) {
            return convertRemarkMonitoring(currentCanData.vcu1D4?.isoltMtrStpReq);
        }
        return "-";
    };

    const getVcu1D4CounterValue = () => {
        if (selectedVcu1D4.includes(Common.EVSOLUTION_V1_COUNTER_KEY) && currentCanData !== undefined) {
            return String(currentCanData.vcu1D4?.counter);
        }
        return "-";
    };

    const getVcu1D4ChecksumValue = () => {
        if (selectedVcu1D4.includes(Common.EVSOLUTION_V1_CHECKSUM_KEY) && currentCanData !== undefined) {
            return String(currentCanData.vcu1D4?.checksum);
        }
        return "-";
    };

    const onChangeVcu1D4 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu1D4(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu1D4: Array<TypeUtils.ChartData> = [];

        if (selectedVcu1D4.includes(Common.EVSOLUTION_V1_MAIN_CONTACTOR_CONTROL_KEY)) chartDatasVcu1D4.push(chartVcu1D4MainContactorControl);
        if (selectedVcu1D4.includes(Common.EVSOLUTION_V1_ISOLT_MTR_STP_REQ_KEY)) chartDatasVcu1D4.push(chartVcu1D4IsoltMtrStpReq);
        if (selectedVcu1D4.includes(Common.EVSOLUTION_V1_COUNTER_KEY)) chartDatasVcu1D4.push(chartVcu1D4Counter);
        if (selectedVcu1D4.includes(Common.EVSOLUTION_V1_CHECKSUM_KEY)) chartDatasVcu1D4.push(chartVcu1D4Checksum);

        setSeriesChartDatasVcu1D4(chartDatasVcu1D4);
    }, [selectedVcu1D4, chartVcu1D4MainContactorControl, chartVcu1D4IsoltMtrStpReq, chartVcu1D4Counter, chartVcu1D4Checksum]);

    const tableDataVcu1D4: CanTableType[] = [
        {
            key: Common.EVSOLUTION_V1_MAIN_CONTACTOR_CONTROL_KEY,
            name: Common.EVSOLUTION_V1_MAIN_CONTACTOR_CONTROL_NAME,
            value: getVcu1D4MainContactorControlValue(),
        },
        {
            key: Common.EVSOLUTION_V1_ISOLT_MTR_STP_REQ_KEY,
            name: Common.EVSOLUTION_V1_ISOLT_MTR_STP_REQ_NAME,
            value: getVcu1D4IsoltMtrStpReqValue(),
        },
        {
            key: Common.EVSOLUTION_V1_COUNTER_KEY,
            name: Common.EVSOLUTION_V1_COUNTER_NAME,
            value: getVcu1D4CounterValue(),
        },
        {
            key: Common.EVSOLUTION_V1_CHECKSUM_KEY,
            name: Common.EVSOLUTION_V1_CHECKSUM_NAME,
            value: getVcu1D4ChecksumValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Vcu1D5
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu1D5PanelOpen, setVcu1D5PanelOpen] = useState(false);
    const [vcu1D5ChartMounted, setVcu1D5ChartMounted] = useState(false);
    const [selectedVcu1D5, setSelectedVcu1D5] = useState<Array<React.Key>>([]);

    const [seriesChartDatasVcu1D5, setSeriesChartDatasVcu1D5] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu1D5EstimatedEptCoolantFlow, setChartVcu1D5EstimatedEptCoolantFlow] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V2_ESTIMATED_EPT_COOLANT_FLOW_NAME,
        data: [],
    });

    const [chartVcu1D5EptCoolantTemp, setChartVcu1D5EptCoolantTemp] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V2_EPT_COOLANT_TEMP_NAME,
        data: [],
    });

    const [chartVcu1D5CommandMode, setChartVcu1D5CommandMode] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V2_COMMAND_MODE_NAME,
        data: [],
    });

    const [chartVcu1D5ActvDischargeReq, setChartVcu1D5ActvDischargeReq] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V2_ACTV_DISCHARGE_REQ_NAME,
        data: [],
    });

    const [chartVcu1D5OperationModeCmd, setChartVcu1D5OperationModeCmd] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V2_OPERATION_MODE_CMD_NAME,
        data: [],
    });

    const [chartVcu1D5TorqueCommand, setChartVcu1D5TorqueCommand] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V2_TORQUE_COMMAND_NAME,
        data: [],
    });

    const [chartVcu1D5Counter, setChartVcu1D5Counter] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V2_COUNTER_NAME,
        data: [],
    });

    const [chartVcu1D5Checksum, setChartVcu1D5Checksum] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_V2_CHECKSUM_NAME,
        data: [],
    });

    const getVcu1D5EstimatedEptCoolantFlowValue = () => {
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_ESTIMATED_EPT_COOLANT_FLOW_KEY) && currentCanData !== undefined) {
            return String(currentCanData.vcu1D5?.estimatedEptCoolantFlow);
        }
        return "-";
    };

    const getVcu1D5EptCoolantTempValue = () => {
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_EPT_COOLANT_TEMP_KEY) && currentCanData !== undefined) {
            return String(currentCanData.vcu1D5?.eptCoolantTemp);
        }
        return "-";
    };

    const getVcu1D5CommandModeValue = () => {
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_COMMAND_MODE_KEY) && currentCanData !== undefined) {
            return convertRemarkTorqueMode(currentCanData.vcu1D5?.commandMode);
        }
        return "-";
    };

    const getVcu1D5ActvDischargeReqValue = () => {
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_ACTV_DISCHARGE_REQ_KEY) && currentCanData !== undefined) {
            return convertRemarkRequest(currentCanData.vcu1D5?.actvDischargeReq);
        }
        return "-";
    };

    const getVcu1D5OperationModeCmdValue = () => {
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_OPERATION_MODE_CMD_KEY) && currentCanData !== undefined) {
            return convertRemarkOperationalModeCmd(currentCanData.vcu1D5?.operationModeCmd);
        }
        return "-";
    };

    const getVcu1D5TorqueCommandValue = () => {
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_TORQUE_COMMAND_KEY) && currentCanData !== undefined) {
            return String(currentCanData.vcu1D5?.torqueCommand);
        }
        return "-";
    };

    const getVcu1D5CounterValue = () => {
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_COUNTER_KEY) && currentCanData !== undefined) {
            return String(currentCanData.vcu1D5?.counter);
        }
        return "-";
    };

    const getVcu1D5ChecksumValue = () => {
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_CHECKSUM_KEY) && currentCanData !== undefined) {
            return String(currentCanData.vcu1D5?.checksum);
        }
        return "-";
    };

    const onChangeVcu1D5 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu1D5(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu1D5: Array<TypeUtils.ChartData> = [];

        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_ESTIMATED_EPT_COOLANT_FLOW_KEY)) chartDatasVcu1D5.push(chartVcu1D5EstimatedEptCoolantFlow);
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_EPT_COOLANT_TEMP_KEY)) chartDatasVcu1D5.push(chartVcu1D5EptCoolantTemp);
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_COMMAND_MODE_KEY)) chartDatasVcu1D5.push(chartVcu1D5CommandMode);
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_ACTV_DISCHARGE_REQ_KEY)) chartDatasVcu1D5.push(chartVcu1D5ActvDischargeReq);
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_OPERATION_MODE_CMD_KEY)) chartDatasVcu1D5.push(chartVcu1D5OperationModeCmd);
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_TORQUE_COMMAND_KEY)) chartDatasVcu1D5.push(chartVcu1D5TorqueCommand);
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_COUNTER_KEY)) chartDatasVcu1D5.push(chartVcu1D5Counter);
        if (selectedVcu1D5.includes(Common.EVSOLUTION_V2_CHECKSUM_KEY)) chartDatasVcu1D5.push(chartVcu1D5Checksum);

        setSeriesChartDatasVcu1D5(chartDatasVcu1D5);
    }, [
        selectedVcu1D5,
        chartVcu1D5EstimatedEptCoolantFlow,
        chartVcu1D5EptCoolantTemp,
        chartVcu1D5CommandMode,
        chartVcu1D5ActvDischargeReq,
        chartVcu1D5OperationModeCmd,
        chartVcu1D5TorqueCommand,
        chartVcu1D5Counter,
        chartVcu1D5Checksum,
    ]);

    const tableDataVcu1D5: CanTableType[] = [
        {
            key: Common.EVSOLUTION_V2_ESTIMATED_EPT_COOLANT_FLOW_KEY,
            name: Common.EVSOLUTION_V2_ESTIMATED_EPT_COOLANT_FLOW_NAME,
            value: getVcu1D5EstimatedEptCoolantFlowValue(),
        },
        {
            key: Common.EVSOLUTION_V2_EPT_COOLANT_TEMP_KEY,
            name: Common.EVSOLUTION_V2_EPT_COOLANT_TEMP_NAME,
            value: getVcu1D5EptCoolantTempValue(),
        },
        {
            key: Common.EVSOLUTION_V2_COMMAND_MODE_KEY,
            name: Common.EVSOLUTION_V2_COMMAND_MODE_NAME,
            value: getVcu1D5CommandModeValue(),
        },
        {
            key: Common.EVSOLUTION_V2_ACTV_DISCHARGE_REQ_KEY,
            name: Common.EVSOLUTION_V2_ACTV_DISCHARGE_REQ_NAME,
            value: getVcu1D5ActvDischargeReqValue(),
        },
        {
            key: Common.EVSOLUTION_V2_OPERATION_MODE_CMD_KEY,
            name: Common.EVSOLUTION_V2_OPERATION_MODE_CMD_NAME,
            value: getVcu1D5OperationModeCmdValue(),
        },
        {
            key: Common.EVSOLUTION_V2_TORQUE_COMMAND_KEY,
            name: Common.EVSOLUTION_V2_TORQUE_COMMAND_NAME,
            value: getVcu1D5TorqueCommandValue(),
        },
        {
            key: Common.EVSOLUTION_V2_COUNTER_KEY,
            name: Common.EVSOLUTION_V2_COUNTER_NAME,
            value: getVcu1D5CounterValue(),
        },
        {
            key: Common.EVSOLUTION_V2_CHECKSUM_KEY,
            name: Common.EVSOLUTION_V2_CHECKSUM_NAME,
            value: getVcu1D5ChecksumValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Evcc341
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [evcc341PanelOpen, setEvcc341PanelOpen] = useState(false);
    const [evcc341ChartMounted, setEvcc341ChartMounted] = useState(false);
    const [selectedEvcc341, setSelectedEvcc341] = useState<Array<React.Key>>([]);

    const [seriesChartDatasEvcc341, setSeriesChartDatasEvcc341] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartEvcc341PdStat, setChartEvcc3414PdStat] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_PD_STAT_NAME,
        data: [],
    });

    const getEvcc341PdStatValue = () => {
        if (selectedEvcc341.includes(Common.EVSOLUTION_PD_STAT_KEY) && currentCanData !== undefined) {
            return convertRemarkPdStat(currentCanData.evcc341?.pdStat);
        }
        return "-";
    };

    const onChangeEvcc341 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedEvcc341(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasEvcc341: Array<TypeUtils.ChartData> = [];

        if (selectedEvcc341.includes(Common.EVSOLUTION_PD_STAT_KEY)) chartDatasEvcc341.push(chartEvcc341PdStat);

        setSeriesChartDatasEvcc341(chartDatasEvcc341);
    }, [selectedEvcc341, chartEvcc341PdStat]);

    const tableDataEvcc341: CanTableType[] = [
        {
            key: Common.EVSOLUTION_PD_STAT_KEY,
            name: Common.EVSOLUTION_PD_STAT_NAME,
            value: getEvcc341PdStatValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Evcc343
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [evcc343PanelOpen, setEvcc343PanelOpen] = useState(false);
    const [evcc343ChartMounted, setEvcc343ChartMounted] = useState(false);
    const [selectedEvcc343, setSelectedEvcc343] = useState<Array<React.Key>>([]);

    const [seriesChartDatasEvcc343, setSeriesChartDatasEvcc343] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartEvcc343EvseChgFinished, setChartEvcc343EvseChgFinished] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_EVSE_CHG_FINISHED_NAME,
        data: [],
    });

    const getEvcc343EvseChgFinishedValue = () => {
        if (selectedEvcc343.includes(Common.EVSOLUTION_EVSE_CHG_FINISHED_KEY) && currentCanData !== undefined) {
            return convertRemarkEvseChgFinished(currentCanData.evcc343?.evseChgFinished);
        }
        return "-";
    };

    const onChangeEvcc343 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedEvcc343(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasEvcc343: Array<TypeUtils.ChartData> = [];

        if (selectedEvcc343.includes(Common.EVSOLUTION_EVSE_CHG_FINISHED_KEY)) chartDatasEvcc343.push(chartEvcc343EvseChgFinished);

        setSeriesChartDatasEvcc343(chartDatasEvcc343);
    }, [selectedEvcc343, chartEvcc343EvseChgFinished]);

    const tableDataEvcc343: CanTableType[] = [
        {
            key: Common.EVSOLUTION_EVSE_CHG_FINISHED_KEY,
            name: Common.EVSOLUTION_EVSE_CHG_FINISHED_NAME,
            value: getEvcc343EvseChgFinishedValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Ehbi080
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [ehbi080PanelOpen, setEhbi080PanelOpen] = useState(false);
    const [ehbi080ChartMounted, setEhbi080ChartMounted] = useState(false);
    const [selectedEhbi080, setSelectedEhbi080] = useState<Array<React.Key>>([]);

    const [seriesChartDatasEhbi080, setSeriesChartDatasEhbi080] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartEhbi080Vs, setChartEhbi080Vs] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_VS_NAME,
        data: [],
    });

    const getEhbi080VsValue = () => {
        if (selectedEhbi080.includes(Common.EVSOLUTION_VS_KEY) && currentCanData !== undefined) {
            return convertRemarkWithUnit(currentCanData.ehbi080?.vs, Common.UNIT_SPEED);
        }
        return "-";
    };

    const onChangeEhbi080 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedEhbi080(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasEhbi080: Array<TypeUtils.ChartData> = [];

        if (selectedEhbi080.includes(Common.EVSOLUTION_VS_KEY)) chartDatasEhbi080.push(chartEhbi080Vs);

        setSeriesChartDatasEhbi080(chartDatasEhbi080);
    }, [selectedEhbi080, chartEhbi080Vs]);

    const tableDataEhbi080: CanTableType[] = [
        {
            key: Common.EVSOLUTION_VS_KEY,
            name: Common.EVSOLUTION_VS_NAME,
            value: getEhbi080VsValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Vcu090
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu090PanelOpen, setVcu090PanelOpen] = useState(false);
    const [vcu090ChartMounted, setVcu090ChartMounted] = useState(false);
    const [selectedVcu090, setSelectedVcu090] = useState<Array<React.Key>>([]);

    const [seriesChartDatasVcu090, setSeriesChartDatasVcu090] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu090GearStateEhbi, setChartVcu090GearStateEhbi] = useState<TypeUtils.ChartData>({
        name: Common.EVSOLUTION_GEAR_STATE_EHBI_NAME,
        data: [],
    });

    const getVcu090GearStateEhbiValue = () => {
        if (selectedVcu090.includes(Common.EVSOLUTION_GEAR_STATE_EHBI_KEY) && currentCanData !== undefined) {
            return convertRemarkGearStateEhbi(currentCanData.vcu090?.gearStateEhbi);
        }
        return "-";
    };

    const onChangeVcu090 = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu090(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu090: Array<TypeUtils.ChartData> = [];

        if (selectedVcu090.includes(Common.EVSOLUTION_GEAR_STATE_EHBI_KEY)) chartDatasVcu090.push(chartVcu090GearStateEhbi);

        setSeriesChartDatasVcu090(chartDatasVcu090);
    }, [selectedVcu090, chartVcu090GearStateEhbi]);

    const tableDataVcu090: CanTableType[] = [
        {
            key: Common.EVSOLUTION_GEAR_STATE_EHBI_KEY,
            name: Common.EVSOLUTION_GEAR_STATE_EHBI_NAME,
            value: getVcu090GearStateEhbiValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    useEffect(() => {
        if (vehicleInfo?.makerModel?.maker?.makerName === Common.VehicleMaker.EVSolution) {
            //#region Bms1D9
            const bms1D9BatPackStatusDatas: TypeUtils.ChartElement[] = [];
            const bms1D9OperationModeDatas: TypeUtils.ChartElement[] = [];
            const bms1D9DcLinkVoltDatas: TypeUtils.ChartElement[] = [];
            const bms1D9BatPackCurrDatas: TypeUtils.ChartElement[] = [];
            const bms1D9MainMinusContactorCoilStateDatas: TypeUtils.ChartElement[] = [];
            const bms1D9MainPlusContactorCoilStateDatas: TypeUtils.ChartElement[] = [];
            const bms1D9PreChargeContactorCoilStateDatas: TypeUtils.ChartElement[] = [];
            const bms1D9IgnStatDatas: TypeUtils.ChartElement[] = [];
            const bms1D9HvilStatusDatas: TypeUtils.ChartElement[] = [];
            const bms1D9CounterDatas: TypeUtils.ChartElement[] = [];
            const bms1D9MainMinusContactorStateDatas: TypeUtils.ChartElement[] = [];
            const bms1D9MainPlusContactorStateDatas: TypeUtils.ChartElement[] = [];
            const bms1D9PreChargeContactorStateDatas: TypeUtils.ChartElement[] = [];
            const bms1D9ContactorOffRequestDatas: TypeUtils.ChartElement[] = [];
            const bms1D9ChecksumDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Bms321
            const bms321BatPackVoltDatas: TypeUtils.ChartElement[] = [];
            const bms321BmsModeDatas: TypeUtils.ChartElement[] = [];
            const bms321WaterPumpStatusDatas: TypeUtils.ChartElement[] = [];
            const bms321BalancingStatusDatas: TypeUtils.ChartElement[] = [];
            const bms321BatPackAsocDatas: TypeUtils.ChartElement[] = [];
            const bms321BatPackRsocDatas: TypeUtils.ChartElement[] = [];
            const bms321BatPackSohDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Bms322

            const bms322BatMinCellVoltDatas: TypeUtils.ChartElement[] = [];
            const bms322BatMaxCellVoltDatas: TypeUtils.ChartElement[] = [];
            const bms322BatAvgCellVoltDatas: TypeUtils.ChartElement[] = [];
            const bms322BatSumVoltDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Bms323
            const bms323BatMinTempDatas: TypeUtils.ChartElement[] = [];
            const bms323BatMaxTempDatas: TypeUtils.ChartElement[] = [];
            const bms323BatAvgTempDatas: TypeUtils.ChartElement[] = [];
            const bms323BatMinTempLocationDatas: TypeUtils.ChartElement[] = [];
            const bms323BatMaxTempLocationDatas: TypeUtils.ChartElement[] = [];
            const bms323CoolingPumpFeedbackStatusDatas: TypeUtils.ChartElement[] = [];
            const bms323CoolingRequestDatas: TypeUtils.ChartElement[] = [];
            const bms323ChargingStopDatas: TypeUtils.ChartElement[] = [];
            const bms323BhcStsOwTsDatas: TypeUtils.ChartElement[] = [];
            const bms323BhcStsWhuWtODatas: TypeUtils.ChartElement[] = [];
            const bms323BhcStsErrDatas: TypeUtils.ChartElement[] = [];
            const bms323AuxBatteryDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Bms324
            const bms324ChargePowerAvailable2Datas: TypeUtils.ChartElement[] = [];
            const bms324DischargePowerAvailable2Datas: TypeUtils.ChartElement[] = [];
            const bms324ChargePowerAvailable10Datas: TypeUtils.ChartElement[] = [];
            const bms324DischargePowerAvailable10Datas: TypeUtils.ChartElement[] = [];
            const bms324BatPackSoeDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Bms325
            const bms325ChargeCurrLimitDatas: TypeUtils.ChartElement[] = [];
            const bms325ChargeVoltLimitDatas: TypeUtils.ChartElement[] = [];
            const bms325InstantPowerConsumptionDatas: TypeUtils.ChartElement[] = [];
            const bms325MinIsolationResistanceDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Bms326
            const bms326HwVerDatas: TypeUtils.ChartElement[] = [];
            const bms326SwVerDatas: TypeUtils.ChartElement[] = [];
            const bms326BootVerDatas: TypeUtils.ChartElement[] = [];
            const bms326IntFltDatas: TypeUtils.ChartElement[] = [];
            const bms326CmiFltInitDatas: TypeUtils.ChartElement[] = [];
            const bms326CmiFltDatas: TypeUtils.ChartElement[] = [];
            const bms326FetFltDatas: TypeUtils.ChartElement[] = [];
            const bms326RlyMnCsDatas: TypeUtils.ChartElement[] = [];
            const bms326RlyMpCsDatas: TypeUtils.ChartElement[] = [];
            const bms326ItempShDatas: TypeUtils.ChartElement[] = [];
            const bms326ItempSlDatas: TypeUtils.ChartElement[] = [];
            const bms326IsoFltDatas: TypeUtils.ChartElement[] = [];
            const bms326CrashOpnDatas: TypeUtils.ChartElement[] = [];
            const bms326CrashHwDatas: TypeUtils.ChartElement[] = [];
            const bms326CrashCanDatas: TypeUtils.ChartElement[] = [];
            const bms326VcuLcmDatas: TypeUtils.ChartElement[] = [];
            const bms326CrtSensWanDatas: TypeUtils.ChartElement[] = [];
            const bms326CrtSensDevDatas: TypeUtils.ChartElement[] = [];
            const bms326EcanBusOffDatas: TypeUtils.ChartElement[] = [];
            const bms326PcanBusOffDatas: TypeUtils.ChartElement[] = [];
            const bms326HeaterFltDatas: TypeUtils.ChartElement[] = [];
            const bms326RlyMnCosDatas: TypeUtils.ChartElement[] = [];
            const bms326RlyMpCosDatas: TypeUtils.ChartElement[] = [];
            const bms326RlyPcCosDatas: TypeUtils.ChartElement[] = [];
            const bms326RlyMnCcsDatas: TypeUtils.ChartElement[] = [];
            const bms326RlyMpCcsatas: TypeUtils.ChartElement[] = [];
            const bms326RlyPcCcsDatas: TypeUtils.ChartElement[] = [];
            const bms326CrashNrDatas: TypeUtils.ChartElement[] = [];
            const bms326CtempFltAllDatas: TypeUtils.ChartElement[] = [];
            const bms326CellOpnDatas: TypeUtils.ChartElement[] = [];
            const bms326CtempFltDatas: TypeUtils.ChartElement[] = [];
            const bms326CvHFltDatas: TypeUtils.ChartElement[] = [];
            const bms326CvLFltDatas: TypeUtils.ChartElement[] = [];
            const bms326CvHWanDatas: TypeUtils.ChartElement[] = [];
            const bms326CvLWanDatas: TypeUtils.ChartElement[] = [];
            const bms326CvDevOcvFltDatas: TypeUtils.ChartElement[] = [];
            const bms326CvDevFltDatas: TypeUtils.ChartElement[] = [];
            const bms326PvHFltDatas: TypeUtils.ChartElement[] = [];
            const bms326PvLFltDatas: TypeUtils.ChartElement[] = [];
            const bms326PvHWanDatas: TypeUtils.ChartElement[] = [];
            const bms326PvLWanDatas: TypeUtils.ChartElement[] = [];
            const bms326CtHFltDatas: TypeUtils.ChartElement[] = [];
            const bms326CtHWanDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Mcu1E1
            const mcu1E1MotorTorqueEstimatedRs1Datas: TypeUtils.ChartElement[] = [];
            const mcu1E1MotorTorqueEstimatedDatas: TypeUtils.ChartElement[] = [];
            const mcu1E1MotorSpeedDatas: TypeUtils.ChartElement[] = [];
            const mcu1E1CounterDatas: TypeUtils.ChartElement[] = [];
            const mcu1E1ChecksumDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Vcu1D4
            const vcu1D4MainContactorControlDatas: TypeUtils.ChartElement[] = [];
            const vcu1D4IsoltMtrStpReqDatas: TypeUtils.ChartElement[] = [];
            const vcu1D4CounterDatas: TypeUtils.ChartElement[] = [];
            const vcu1D4ChecksumDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Vcu1D5
            const vcu1D5EstimatedEptCoolantFlowDatas: TypeUtils.ChartElement[] = [];
            const vcu1D5EptCoolantTempDatas: TypeUtils.ChartElement[] = [];
            const vcu1D5CommandModeDatas: TypeUtils.ChartElement[] = [];
            const vcu1D5ActvDischargeReqDatas: TypeUtils.ChartElement[] = [];
            const vcu1D5OperationModeCmdDatas: TypeUtils.ChartElement[] = [];
            const vcu1D5TorqueCommandDatas: TypeUtils.ChartElement[] = [];
            const vcu1D5CounterDatas: TypeUtils.ChartElement[] = [];
            const vcu1D5ChecksumDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Evcc341
            const evcc341PdStatDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Evcc343
            const evcc343EvseChgFinishedDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Ehbi080
            const ehbi080VsDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            //#region Vcu090
            const vcu090GearStateEhbiDatas: TypeUtils.ChartElement[] = [];
            //#endregion

            runningCanDataList?.forEach((data) => {
                const canData = data as CanDataEVSolution.CanData;

                const time = moment(canData.dataTime, Common.FORMAT_DATE_TIME_MILLISECOND);

                //#region Bms1D9
                bms1D9BatPackStatusDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.batPackStatus || 0,
                });

                bms1D9OperationModeDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.operationMode || 0,
                });

                bms1D9DcLinkVoltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.dcLinkVolt || 0,
                });

                bms1D9BatPackCurrDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.batPackCurr || 0,
                });

                bms1D9MainMinusContactorCoilStateDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.mainMinusContactorCoilState || 0,
                });

                bms1D9MainPlusContactorCoilStateDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.mainPlusContactorCoilState || 0,
                });

                bms1D9PreChargeContactorCoilStateDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.preChargeContactorCoilState || 0,
                });

                bms1D9IgnStatDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.ignStat || 0,
                });

                bms1D9HvilStatusDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.hvilStatus || 0,
                });

                bms1D9CounterDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.counter || 0,
                });

                bms1D9MainMinusContactorStateDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.mainMinusContactorState || 0,
                });

                bms1D9MainPlusContactorStateDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.mainPlusContactorState || 0,
                });

                bms1D9PreChargeContactorStateDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.preChargeContactorState || 0,
                });

                bms1D9ContactorOffRequestDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.contactorOffRequest || 0,
                });

                bms1D9ChecksumDatas.push({
                    x: time.valueOf(),
                    y: canData.bms1D9?.checksum || 0,
                });
                //#endregion

                //#region Bms321
                bms321BatPackVoltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms321?.batPackVolt || 0,
                });

                bms321BmsModeDatas.push({
                    x: time.valueOf(),
                    y: canData.bms321?.bmsMode || 0,
                });

                bms321WaterPumpStatusDatas.push({
                    x: time.valueOf(),
                    y: canData.bms321?.waterPumpStatus || 0,
                });

                bms321BalancingStatusDatas.push({
                    x: time.valueOf(),
                    y: canData.bms321?.balancingStatus || 0,
                });

                bms321BatPackAsocDatas.push({
                    x: time.valueOf(),
                    y: canData.bms321?.batPackAsoc || 0,
                });

                bms321BatPackRsocDatas.push({
                    x: time.valueOf(),
                    y: canData.bms321?.batPackRsoc || 0,
                });

                bms321BatPackSohDatas.push({
                    x: time.valueOf(),
                    y: canData.bms321?.batPackSoh || 0,
                });
                //#endregion

                //#region Bms322
                bms322BatMinCellVoltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms322?.batMinCellVolt || 0,
                });

                bms322BatMaxCellVoltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms322?.batMaxCellVolt || 0,
                });

                bms322BatAvgCellVoltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms322?.batAvgCellVolt || 0,
                });

                bms322BatSumVoltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms322?.batSumVolt || 0,
                });
                //#endregion

                //#region Bms323
                bms323BatMinTempDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.batMinTemp || 0,
                });

                bms323BatMaxTempDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.batMaxTemp || 0,
                });

                bms323BatAvgTempDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.batAvgTemp || 0,
                });

                bms323BatMinTempLocationDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.batMinTempLocation || 0,
                });

                bms323BatMaxTempLocationDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.batMaxTempLocation || 0,
                });

                bms323CoolingPumpFeedbackStatusDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.coolingPumpFeedbackStatus || 0,
                });

                bms323CoolingRequestDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.coolingRequest || 0,
                });

                bms323ChargingStopDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.chargingStop || 0,
                });

                bms323BhcStsOwTsDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.bhcStsOwTs || 0,
                });

                bms323BhcStsWhuWtODatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.bhcStsWhuWtO || 0,
                });

                bms323BhcStsErrDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.bhcStsErr || 0,
                });

                bms323AuxBatteryDatas.push({
                    x: time.valueOf(),
                    y: canData.bms323?.auxBattery || 0,
                });
                //#endregion

                //#region Bms324
                bms324ChargePowerAvailable2Datas.push({
                    x: time.valueOf(),
                    y: canData.bms324?.chargePowerAvailable2 || 0,
                });

                bms324DischargePowerAvailable2Datas.push({
                    x: time.valueOf(),
                    y: canData.bms324?.dischargePowerAvailable2 || 0,
                });

                bms324ChargePowerAvailable10Datas.push({
                    x: time.valueOf(),
                    y: canData.bms324?.chargePowerAvailable10 || 0,
                });

                bms324DischargePowerAvailable10Datas.push({
                    x: time.valueOf(),
                    y: canData.bms324?.dischargePowerAvailable10 || 0,
                });

                bms324BatPackSoeDatas.push({
                    x: time.valueOf(),
                    y: canData.bms324?.batPackSoe || 0,
                });
                //#endregion

                //#region Bms325
                bms325ChargeCurrLimitDatas.push({
                    x: time.valueOf(),
                    y: canData.bms325?.chargeCurrLimit || 0,
                });

                bms325ChargeVoltLimitDatas.push({
                    x: time.valueOf(),
                    y: canData.bms325?.chargeVoltLimit || 0,
                });

                bms325InstantPowerConsumptionDatas.push({
                    x: time.valueOf(),
                    y: canData.bms325?.instantPowerConsumption || 0,
                });

                bms325MinIsolationResistanceDatas.push({
                    x: time.valueOf(),
                    y: canData.bms325?.minIsolationResistance || 0,
                });
                //#endregion

                //#region Bms326
                bms326HwVerDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.hwVer || 0,
                });

                bms326SwVerDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.swVer || 0,
                });

                bms326BootVerDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.bootVer || 0,
                });

                bms326IntFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.intFlt || 0,
                });

                bms326CmiFltInitDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cmiFltInit || 0,
                });

                bms326CmiFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cmiFlt || 0,
                });

                bms326FetFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.fetFlt || 0,
                });

                bms326RlyMnCsDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.rlyMnCs || 0,
                });

                bms326RlyMpCsDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.rlyMpCs || 0,
                });

                bms326ItempShDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.itempSh || 0,
                });

                bms326ItempSlDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.itempSl || 0,
                });

                bms326IsoFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.isoFlt || 0,
                });

                bms326CrashOpnDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.crashOpn || 0,
                });

                bms326CrashHwDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.crashHw || 0,
                });

                bms326CrashCanDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.crashCan || 0,
                });
                bms326VcuLcmDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.vcuLcm || 0,
                });

                bms326CrtSensWanDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.crtSensWan || 0,
                });

                bms326CrtSensDevDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.crtSensDev || 0,
                });

                bms326EcanBusOffDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.ecanBusOff || 0,
                });

                bms326PcanBusOffDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.pcanBusOff || 0,
                });

                bms326HeaterFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.heaterFlt || 0,
                });

                bms326RlyMnCosDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.rlyMnCos || 0,
                });

                bms326RlyMpCosDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.rlyMpCos || 0,
                });

                bms326RlyPcCosDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.rlyPcCos || 0,
                });

                bms326RlyMnCcsDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.rlyMnCcs || 0,
                });

                bms326RlyMpCcsatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.rlyMpCcs || 0,
                });

                bms326RlyPcCcsDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.rlyPcCcs || 0,
                });

                bms326CrashNrDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.crashNr || 0,
                });

                bms326CtempFltAllDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.ctempFltAll || 0,
                });

                bms326CellOpnDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cellOpn || 0,
                });

                bms326CtempFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.ctempFlt || 0,
                });

                bms326CvHFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cvHFlt || 0,
                });

                bms326CvLFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cvLFlt || 0,
                });

                bms326CvHWanDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cvHWan || 0,
                });

                bms326CvLWanDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cvLWan || 0,
                });

                bms326CvDevOcvFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cvDevOcvFlt || 0,
                });

                bms326CvDevFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.cvDevFlt || 0,
                });

                bms326PvHFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.pvHFlt || 0,
                });

                bms326PvLFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.pvLFlt || 0,
                });

                bms326PvHWanDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.pvHWan || 0,
                });

                bms326PvLWanDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.pvLWan || 0,
                });

                bms326CtHFltDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.ctHFlt || 0,
                });

                bms326CtHWanDatas.push({
                    x: time.valueOf(),
                    y: canData.bms326?.ctHWan || 0,
                });
                //#endregion

                //#region Mcu1E1
                mcu1E1MotorTorqueEstimatedRs1Datas.push({
                    x: time.valueOf(),
                    y: canData.mcu1E1?.motorTorqueEstimatedRs1 || 0,
                });

                mcu1E1MotorTorqueEstimatedDatas.push({
                    x: time.valueOf(),
                    y: canData.mcu1E1?.motorTorqueEstimated || 0,
                });

                mcu1E1MotorSpeedDatas.push({
                    x: time.valueOf(),
                    y: canData.mcu1E1?.motorSpeed || 0,
                });

                mcu1E1CounterDatas.push({
                    x: time.valueOf(),
                    y: canData.mcu1E1?.counter || 0,
                });

                mcu1E1ChecksumDatas.push({
                    x: time.valueOf(),
                    y: canData.mcu1E1?.checksum || 0,
                });
                //#endregion

                //#region Vcu1D4
                vcu1D4MainContactorControlDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D4?.mainContactorControl || 0,
                });

                vcu1D4IsoltMtrStpReqDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D4?.isoltMtrStpReq || 0,
                });

                vcu1D4CounterDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D4?.counter || 0,
                });

                vcu1D4ChecksumDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D4?.checksum || 0,
                });
                //#endregion

                //#region Vcu1D5
                vcu1D5EstimatedEptCoolantFlowDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D5?.estimatedEptCoolantFlow || 0,
                });

                vcu1D5EptCoolantTempDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D5?.eptCoolantTemp || 0,
                });

                vcu1D5CommandModeDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D5?.commandMode || 0,
                });

                vcu1D5ActvDischargeReqDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D5?.actvDischargeReq || 0,
                });

                vcu1D5OperationModeCmdDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D5?.operationModeCmd || 0,
                });

                vcu1D5TorqueCommandDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D5?.torqueCommand || 0,
                });

                vcu1D5CounterDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D5?.counter || 0,
                });

                vcu1D5ChecksumDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu1D5?.checksum || 0,
                });
                //#endregion

                //#region Evcc341
                evcc341PdStatDatas.push({
                    x: time.valueOf(),
                    y: canData.evcc341?.pdStat || 0,
                });
                //#endregion

                //#region Evcc343
                evcc343EvseChgFinishedDatas.push({
                    x: time.valueOf(),
                    y: canData.evcc343?.evseChgFinished || 0,
                });
                //#endregion

                //#region Ehbi080
                ehbi080VsDatas.push({
                    x: time.valueOf(),
                    y: canData.ehbi080?.vs || 0,
                });
                //#endregion

                //#region Vcu090
                vcu090GearStateEhbiDatas.push({
                    x: time.valueOf(),
                    y: canData.vcu090?.gearStateEhbi || 0,
                });
                //#endregion
            });

            //#region Bms1D9
            setChartBms1D9BatPackStatus({
                ...chartBms1D9BatPackStatus,
                data: bms1D9BatPackStatusDatas,
            });

            setChartBms1D9OperationMode({
                ...chartBms1D9OperationMode,
                data: bms1D9OperationModeDatas,
            });

            setChartBms1D9DcLinkVolt({
                ...chartBms1D9DcLinkVolt,
                data: bms1D9DcLinkVoltDatas,
            });

            setChartBms1D9BatPackCurr({
                ...chartBms1D9BatPackCurr,
                data: bms1D9BatPackCurrDatas,
            });

            setChartBms1D9MainMinusContactorCoilState({
                ...chartBms1D9MainPlusContactorCoilState,
                data: bms1D9MainPlusContactorCoilStateDatas,
            });

            setChartBms1D9MainPlusContactorCoilState({
                ...chartBms1D9BatPackStatus,
                data: bms1D9BatPackStatusDatas,
            });

            setChartBms1D9PreChargeContactorCoilState({
                ...chartBms1D9PreChargeContactorCoilState,
                data: bms1D9PreChargeContactorCoilStateDatas,
            });

            setChartBms1D9IgnStat({
                ...chartBms1D9IgnStat,
                data: bms1D9IgnStatDatas,
            });

            setChartBms1D9HvilStatus({
                ...chartBms1D9HvilStatus,
                data: bms1D9HvilStatusDatas,
            });

            setChartBms1D9Counter({
                ...chartBms1D9Counter,
                data: bms1D9CounterDatas,
            });

            setChartBms1D9MainMinusContactorState({
                ...chartBms1D9MainMinusContactorState,
                data: bms1D9MainMinusContactorStateDatas,
            });

            setChartBms1D9MainPlusContactorState({
                ...chartBms1D9MainPlusContactorState,
                data: bms1D9MainPlusContactorStateDatas,
            });

            setChartBms1D9PreChargeContactorState({
                ...chartBms1D9PreChargeContactorState,
                data: bms1D9PreChargeContactorStateDatas,
            });

            setChartBms1D9ContactorOffRequest({
                ...chartBms1D9ContactorOffRequest,
                data: bms1D9ContactorOffRequestDatas,
            });

            setChartBms1D9Checksum({
                ...chartBms1D9Checksum,
                data: bms1D9ChecksumDatas,
            });
            //#endregion

            //#region Bms321
            setChartBms321BatPackVolt({
                ...chartBms321BatPackVolt,
                data: bms321BatPackVoltDatas,
            });

            setChartBms321BmsMode({
                ...chartBms321BmsMode,
                data: bms321BmsModeDatas,
            });

            setChartBms321WaterPumpStatus({
                ...chartBms321WaterPumpStatus,
                data: bms321WaterPumpStatusDatas,
            });

            setChartBms321BalancingStatus({
                ...chartBms321BalancingStatus,
                data: bms321BalancingStatusDatas,
            });

            setChartBms321BatPackAsoc({
                ...chartBms321BatPackAsoc,
                data: bms321BatPackAsocDatas,
            });

            setChartBms321BatPackRsoc({
                ...chartBms321BatPackRsoc,
                data: bms321BatPackRsocDatas,
            });

            setChartBms321BatPackSoh({
                ...chartBms321BatPackSoh,
                data: bms321BatPackSohDatas,
            });
            //#endregion

            //#region Bms322
            setChartBms322BatMinCellVolt({
                ...chartBms322BatMinCellVolt,
                data: bms322BatMinCellVoltDatas,
            });

            setChartBms322BatMaxCellVolt({
                ...chartBms322BatMaxCellVolt,
                data: bms322BatMaxCellVoltDatas,
            });

            setChartBms322BatAvgCellVolt({
                ...chartBms322BatAvgCellVolt,
                data: bms322BatAvgCellVoltDatas,
            });

            setChartBms322BatSumVolt({
                ...chartBms322BatSumVolt,
                data: bms322BatSumVoltDatas,
            });
            //#endregion

            //#region Bms323
            setChartBms323BatMinTemp({
                ...chartBms323BatMinTemp,
                data: bms323BatMinTempDatas,
            });

            setChartBms323BatMaxTemp({
                ...chartBms323BatMaxTemp,
                data: bms323BatMaxTempDatas,
            });

            setChartBms323BatAvgTemp({
                ...chartBms323BatAvgTemp,
                data: bms323BatAvgTempDatas,
            });

            setChartBms323BatMinTempLocation({
                ...chartBms323BatMinTempLocation,
                data: bms323BatMinTempLocationDatas,
            });

            setChartBms323BatMaxTempLocation({
                ...chartBms323BatMaxTempLocation,
                data: bms323BatMaxTempLocationDatas,
            });

            setChartBms323CoolingPumpFeedbackStatus({
                ...chartBms323CoolingPumpFeedbackStatus,
                data: bms323CoolingPumpFeedbackStatusDatas,
            });

            setChartBms323CoolingRequest({
                ...chartBms323CoolingRequest,
                data: bms323CoolingRequestDatas,
            });

            setChartBms323ChargingStop({
                ...chartBms323ChargingStop,
                data: bms323ChargingStopDatas,
            });

            setChartBms323BhcStsOwTs({
                ...chartBms323BhcStsOwTs,
                data: bms323BhcStsOwTsDatas,
            });

            setChartBms323BhcStsWhuWtO({
                ...chartBms323BhcStsWhuWtO,
                data: bms323BhcStsWhuWtODatas,
            });

            setChartBms323BhcStsErr({
                ...chartBms323BhcStsErr,
                data: bms323BhcStsErrDatas,
            });

            setChartBms323AuxBattery({
                ...chartBms323AuxBattery,
                data: bms323AuxBatteryDatas,
            });
            //#endregion

            //#region Bms324
            setChartBms324ChargePowerAvailable2({
                ...chartBms324ChargePowerAvailable2,
                data: bms324ChargePowerAvailable2Datas,
            });

            setChartBms324DischargePowerAvailable2({
                ...chartBms324DischargePowerAvailable2,
                data: bms324DischargePowerAvailable2Datas,
            });

            setChartBms324ChargePowerAvailable10({
                ...chartBms324ChargePowerAvailable10,
                data: bms324ChargePowerAvailable10Datas,
            });

            setChartBms324DischargePowerAvailable10({
                ...chartBms324DischargePowerAvailable10,
                data: bms324DischargePowerAvailable10Datas,
            });

            setChartBms324BatPackSoe({
                ...chartBms324BatPackSoe,
                data: bms324BatPackSoeDatas,
            });
            //#endregion

            //#region Bms325
            setChartBms325ChargeCurrLimit({
                ...chartBms325ChargeCurrLimit,
                data: bms325ChargeCurrLimitDatas,
            });

            setChartBms325ChargeVoltLimit({
                ...chartBms325ChargeVoltLimit,
                data: bms325ChargeVoltLimitDatas,
            });

            setChartBms325InstantPowerConsumption({
                ...chartBms325InstantPowerConsumption,
                data: bms325InstantPowerConsumptionDatas,
            });

            setChartBms325MinIsolationResistance({
                ...chartBms325MinIsolationResistance,
                data: bms325MinIsolationResistanceDatas,
            });
            //#endregion

            //#region Bms326
            setChartBms326HwVer({
                ...chartBms326HwVer,
                data: bms326HwVerDatas,
            });

            setChartBms326SwVer({
                ...chartBms326SwVer,
                data: bms326SwVerDatas,
            });

            setChartBms326BootVer({
                ...chartBms326BootVer,
                data: bms326BootVerDatas,
            });

            setChartBms326IntFlt({
                ...chartBms326IntFlt,
                data: bms326IntFltDatas,
            });

            setChartBms326CmiFltInit({
                ...chartBms326CmiFltInit,
                data: bms326CmiFltInitDatas,
            });

            setChartBms326CmiFlt({
                ...chartBms326CmiFlt,
                data: bms326CmiFltDatas,
            });

            setChartBms326FetFlt({
                ...chartBms326FetFlt,
                data: bms326FetFltDatas,
            });

            setChartBms326RlyMnCs({
                ...chartBms326RlyMnCs,
                data: bms326RlyMnCsDatas,
            });

            setChartBms326RlyMpCs({
                ...chartBms326RlyMpCs,
                data: bms326RlyMpCsDatas,
            });

            setChartBms326ItempSh({
                ...chartBms326ItempSh,
                data: bms326ItempShDatas,
            });

            setChartBms326ItempSl({
                ...chartBms326ItempSl,
                data: bms326ItempSlDatas,
            });

            setChartBms326IsoFlt({
                ...chartBms326IsoFlt,
                data: bms326IsoFltDatas,
            });

            setChartBms326CrashOpn({
                ...chartBms326CrashOpn,
                data: bms326CrashOpnDatas,
            });

            setChartBms326CrashHw({
                ...chartBms326CrashHw,
                data: bms326CrashHwDatas,
            });

            setChartBms326CrashCan({
                ...chartBms326CrashCan,
                data: bms326CrashCanDatas,
            });

            setChartBms326VcuLcm({
                ...chartBms326VcuLcm,
                data: bms326VcuLcmDatas,
            });

            setChartBms326CrtSensWan({
                ...chartBms326CrtSensWan,
                data: bms326CrtSensWanDatas,
            });

            setChartBms326CrtSensDev({
                ...chartBms326CrtSensDev,
                data: bms326CrtSensDevDatas,
            });

            setChartBms326EcanBusOff({
                ...chartBms326EcanBusOff,
                data: bms326EcanBusOffDatas,
            });

            setChartBms326PcanBusOff({
                ...chartBms326PcanBusOff,
                data: bms326PcanBusOffDatas,
            });

            setChartBms326HeaterFlt({
                ...chartBms326HeaterFlt,
                data: bms326HeaterFltDatas,
            });

            setChartBms326RlyMnCos({
                ...chartBms326RlyMnCos,
                data: bms326RlyMnCosDatas,
            });

            setChartBms326RlyMpCos({
                ...chartBms326RlyMpCos,
                data: bms326RlyMpCosDatas,
            });

            setChartBms326RlyPcCos({
                ...chartBms326RlyPcCos,
                data: bms326RlyPcCosDatas,
            });

            setChartBms326RlyMnCcs({
                ...chartBms326RlyMnCcs,
                data: bms326RlyMnCcsDatas,
            });

            setChartBms326RlyMpCcs({
                ...chartBms326RlyMpCcs,
                data: bms326RlyMpCcsatas,
            });

            setChartBms326RlyPcCcs({
                ...chartBms326RlyPcCcs,
                data: bms326RlyPcCcsDatas,
            });

            setChartBms326CrashNr({
                ...chartBms326CrashNr,
                data: bms326CrashNrDatas,
            });

            setChartBms326CtempFltAll({
                ...chartBms326CtempFltAll,
                data: bms326CtempFltAllDatas,
            });

            setChartBms326CellOpn({
                ...chartBms326CellOpn,
                data: bms326CellOpnDatas,
            });

            setChartBms326CtempFlt({
                ...chartBms326CtempFlt,
                data: bms326CtempFltDatas,
            });

            setChartBms326CvHFlt({
                ...chartBms326CvHFlt,
                data: bms326CvHFltDatas,
            });

            setChartBms326CvLFlt({
                ...chartBms326CvLFlt,
                data: bms326CvLFltDatas,
            });

            setChartBms326CvHWan({
                ...chartBms326CvHWan,
                data: bms326CvHWanDatas,
            });

            setChartBms326CvLWan({
                ...chartBms326CvLWan,
                data: bms326CvLWanDatas,
            });

            setChartBms326CvDevOcvFlt({
                ...chartBms326CvDevOcvFlt,
                data: bms326CvDevOcvFltDatas,
            });

            setChartBms326CvDevFlt({
                ...chartBms326CvDevFlt,
                data: bms326CvDevFltDatas,
            });

            setChartBms326PvHFlt({
                ...chartBms326PvHFlt,
                data: bms326PvHFltDatas,
            });

            setChartBms326PvLFlt({
                ...chartBms326PvLFlt,
                data: bms326PvLFltDatas,
            });

            setChartBms326PvHWan({
                ...chartBms326PvHWan,
                data: bms326PvHWanDatas,
            });

            setChartBms326PvLWan({
                ...chartBms326PvLWan,
                data: bms326PvLWanDatas,
            });

            setChartBms326CtHFlt({
                ...chartBms326CtHFlt,
                data: bms326CtHFltDatas,
            });

            setChartBms326CtHWan({
                ...chartBms326CtHWan,
                data: bms326CtHWanDatas,
            });
            //#endregion

            //#region Mcu1E1
            setChartMcu1E1MotorTorqueEstimatedRs1({
                ...chartMcu1E1MotorTorqueEstimatedRs1,
                data: mcu1E1MotorTorqueEstimatedRs1Datas,
            });

            setChartMcu1E1MotorTorqueEstimated({
                ...chartMcu1E1MotorTorqueEstimated,
                data: mcu1E1MotorTorqueEstimatedDatas,
            });

            setChartMcu1E1MotorSpeed({
                ...chartMcu1E1MotorSpeed,
                data: mcu1E1MotorSpeedDatas,
            });

            setChartMcu1E1Counter({
                ...chartMcu1E1Counter,
                data: mcu1E1CounterDatas,
            });

            setChartMcu1E1Checksum({
                ...chartMcu1E1Checksum,
                data: mcu1E1ChecksumDatas,
            });
            //#endregion

            //#region Vcu1D4
            setChartVcu1D4MainContactorControl({
                ...chartVcu1D4MainContactorControl,
                data: vcu1D4MainContactorControlDatas,
            });

            setChartVcu1D4IsoltMtrStpReq({
                ...chartVcu1D4IsoltMtrStpReq,
                data: vcu1D4IsoltMtrStpReqDatas,
            });

            setChartVcu1D4Counter({
                ...chartVcu1D4Counter,
                data: vcu1D4CounterDatas,
            });

            setChartVcu1D4Checksum({
                ...chartVcu1D4Checksum,
                data: vcu1D4ChecksumDatas,
            });
            //#endregion

            //#region Vcu1D5
            setChartVcu1D5EstimatedEptCoolantFlow({
                ...chartVcu1D5EstimatedEptCoolantFlow,
                data: vcu1D5EstimatedEptCoolantFlowDatas,
            });

            setChartVcu1D5EptCoolantTemp({
                ...chartVcu1D5EptCoolantTemp,
                data: vcu1D5EptCoolantTempDatas,
            });

            setChartVcu1D5CommandMode({
                ...chartVcu1D5CommandMode,
                data: vcu1D5CommandModeDatas,
            });

            setChartVcu1D5ActvDischargeReq({
                ...chartVcu1D5ActvDischargeReq,
                data: vcu1D5ActvDischargeReqDatas,
            });

            setChartVcu1D5OperationModeCmd({
                ...chartVcu1D5OperationModeCmd,
                data: vcu1D5OperationModeCmdDatas,
            });

            setChartVcu1D5TorqueCommand({
                ...chartVcu1D5TorqueCommand,
                data: vcu1D5TorqueCommandDatas,
            });

            setChartVcu1D5Counter({
                ...chartVcu1D5Counter,
                data: vcu1D5CounterDatas,
            });

            setChartVcu1D5Checksum({
                ...chartVcu1D5Checksum,
                data: vcu1D5ChecksumDatas,
            });
            //#endregion

            //#region Evcc341
            setChartEvcc3414PdStat({
                ...chartEvcc341PdStat,
                data: evcc341PdStatDatas,
            });
            //#endregion

            //#region Evcc343
            setChartEvcc343EvseChgFinished({
                ...chartEvcc343EvseChgFinished,
                data: evcc343EvseChgFinishedDatas,
            });
            //#endregion

            //#region Ehbi080
            setChartEhbi080Vs({
                ...chartEhbi080Vs,
                data: ehbi080VsDatas,
            });
            //#endregion

            //#region Vcu090
            setChartVcu090GearStateEhbi({
                ...chartVcu090GearStateEhbi,
                data: vcu090GearStateEhbiDatas,
            });
            //#endregion
        }
    }, [runningCanDataList]);

    useEffect(() => {
        if (runningCanDataList === undefined || selectedDataPointIndex === undefined) return;

        if (vehicleInfo?.makerModel?.maker?.makerName === Common.VehicleMaker.EVSolution) {
            const canData = runningCanDataList[selectedDataPointIndex] as CanDataEVSolution.CanData;

            setCurrentCanData(canData);
        }
    }, [selectedDataPointIndex]);

    useEffect(() => {
        if (
            bms1D9ChartMounted === true ||
            bms321ChartMounted === true ||
            bms322ChartMounted === true ||
            bms323ChartMounted === true ||
            bms324ChartMounted === true ||
            bms325ChartMounted === true ||
            bms326ChartMounted === true ||
            mcu1E1ChartMounted === true ||
            vcu1D4ChartMounted === true ||
            vcu1D5ChartMounted === true ||
            evcc341ChartMounted === true ||
            evcc343ChartMounted === true ||
            ehbi080ChartMounted === true ||
            vcu090ChartMounted === true
        ) {
            if (onMountedChart !== undefined) onMountedChart();
        }
    }, [
        bms1D9ChartMounted,
        bms321ChartMounted,
        bms322ChartMounted,
        bms323ChartMounted,
        bms324ChartMounted,
        bms325ChartMounted,
        bms326ChartMounted,
        mcu1E1ChartMounted,
        vcu1D4ChartMounted,
        vcu1D5ChartMounted,
        evcc341ChartMounted,
        evcc343ChartMounted,
        ehbi080ChartMounted,
        vcu090ChartMounted,
    ]);

    const convertChartTooltip = (seriesName: string, value: number) => {
        let convertTooltipString = String(value);
        switch (seriesName) {
            case Common.EVSOLUTION_B1_DC_LINK_VOLT_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_VOLTAGE);
                break;
            }

            case Common.EVSOLUTION_B1_BAT_PACK_CURR_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_CURRENT);
                break;
            }

            case Common.EVSOLUTION_VS_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_SPEED);
                break;
            }

            case Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_COIL_STATE_NAME:
            case Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_COIL_STATE_NAME:
            case Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_COIL_STATE_NAME:
            case Common.EVSOLUTION_B1_IGN_STAT_NAME:
            case Common.EVSOLUTION_B1_MAIN_MINUS_CONTACTOR_STATE_NAME:
            case Common.EVSOLUTION_B1_MAIN_PLUS_CONTACTOR_STATE_NAME:
            case Common.EVSOLUTION_B1_PRE_CHARGE_CONTACTOR_STATE_NAME:
            case Common.EVSOLUTION_B2_WATER_PUMP_STATUS_NAME:
            case Common.EVSOLUTION_V1_MAIN_CONTACTOR_CONTROL_NAME: {
                convertTooltipString = convertRemarkContactorCoilState(value);
                break;
            }

            case Common.EVSOLUTION_B1_BAT_PACK_STATUS_NAME: {
                convertTooltipString = convertRemarkBatPackStatus(value);
                break;
            }

            case Common.EVSOLUTION_B1_OPERATION_MODE_NAME: {
                convertTooltipString = convertRemarkOperationMode(value);
                break;
            }

            case Common.EVSOLUTION_B1_HVIL_STATUS_NAME: {
                convertTooltipString = convertRemarkFault(value);
                break;
            }

            case Common.EVSOLUTION_B1_CONTACTOR_OFF_REQUEST_NAME:
            case Common.EVSOLUTION_B4_COOLING_REQUEST_NAME:
            case Common.EVSOLUTION_B4_CHARGING_STOP_NAME:
            case Common.EVSOLUTION_V2_ACTV_DISCHARGE_REQ_NAME: {
                convertTooltipString = convertRemarkRequest(value);
                break;
            }

            case Common.EVSOLUTION_B2_BMS_MODE_NAME: {
                convertTooltipString = convertRemarkBmsMode(value);
                break;
            }

            case Common.EVSOLUTION_B2_BALANCING_STATUS_NAME: {
                convertTooltipString = convertRemarkNoYes(value);
                break;
            }

            case Common.EVSOLUTION_B4_COOLING_PUMP_FEEDBACK_STATUS_NAME: {
                convertTooltipString = convertRemarkCoolingPumpFeedbackStatus(value);
                break;
            }

            case Common.EVSOLUTION_B4_BHC_STS_OW_TS_NAME: {
                convertTooltipString = convertRemarkBhcStsOwTs(value);
                break;
            }

            case Common.EVSOLUTION_B4_BHC_STS_ERR_NAME: {
                convertTooltipString = convertRemarkBhcStsErr(value);
                break;
            }

            case Common.EVSOLUTION_BF_INT_FLT_NAME:
            case Common.EVSOLUTION_BF_CMI_FLT_INIT_NAME:
            case Common.EVSOLUTION_BF_CMI_FLT_NAME:
            case Common.EVSOLUTION_BF_FET_FLT_NAME:
            case Common.EVSOLUTION_BF_RLY_MN_CS_NAME:
            case Common.EVSOLUTION_BF_RLY_MP_CS_NAME:
            case Common.EVSOLUTION_BF_I_TEMP_SH_NAME:
            case Common.EVSOLUTION_BF_I_TEMP_SL_NAME:
            case Common.EVSOLUTION_BF_ISO_FLT_NAME:
            case Common.EVSOLUTION_BF_CRASH_OPN_NAME:
            case Common.EVSOLUTION_BF_CRASH_HW_NAME:
            case Common.EVSOLUTION_BF_CRASH_CAN_NAME:
            case Common.EVSOLUTION_BF_VCU_LCM_NAME:
            case Common.EVSOLUTION_BF_CRT_SENS_WAN_NAME:
            case Common.EVSOLUTION_BF_CRT_SENS_DEV_NAME:
            case Common.EVSOLUTION_BF_ECAN_BUS_OFF_NAME:
            case Common.EVSOLUTION_BF_PCAN_BUS_OFF_NAME:
            case Common.EVSOLUTION_BF_HEATER_FLT_NAME:
            case Common.EVSOLUTION_BF_RLY_MN_COS_NAME:
            case Common.EVSOLUTION_BF_RLY_MP_COS_NAME:
            case Common.EVSOLUTION_BF_RLY_PC_COS_NAME:
            case Common.EVSOLUTION_BF_RLY_MN_CCS_NAME:
            case Common.EVSOLUTION_BF_RLY_MP_CCS_NAME:
            case Common.EVSOLUTION_BF_RLY_PC_CCS_NAME:
            case Common.EVSOLUTION_BF_CRASH_NR_NAME:
            case Common.EVSOLUTION_BF_C_TEMP_FLT_ALL_NAME:
            case Common.EVSOLUTION_BF_CELL_OPN_NAME:
            case Common.EVSOLUTION_BF_C_TEMP_FLT_NAME:
            case Common.EVSOLUTION_BF_CV_H_FLT_NAME:
            case Common.EVSOLUTION_BF_CV_L_FLT_NAME:
            case Common.EVSOLUTION_BF_CV_H_WAN_NAME:
            case Common.EVSOLUTION_BF_CV_L_WAN_NAME:
            case Common.EVSOLUTION_BF_CV_DEV_OCV_FLT_NAME:
            case Common.EVSOLUTION_BF_CV_DEV_FLT_NAME:
            case Common.EVSOLUTION_BF_PV_H_FLT_NAME:
            case Common.EVSOLUTION_BF_PV_L_FLT_NAME:
            case Common.EVSOLUTION_BF_PV_H_WAN_NAME:
            case Common.EVSOLUTION_BF_PV_L_WAN_NAME:
            case Common.EVSOLUTION_BF_CT_H_FLT_NAME:
            case Common.EVSOLUTION_BF_CT_H_WAN_NAME: {
                convertTooltipString = convertRemarkError(value);
                break;
            }

            case Common.EVSOLUTION_V1_ISOLT_MTR_STP_REQ_NAME: {
                convertTooltipString = convertRemarkMonitoring(value);
                break;
            }

            case Common.EVSOLUTION_V2_COMMAND_MODE_NAME: {
                convertTooltipString = convertRemarkTorqueMode(value);
                break;
            }

            case Common.EVSOLUTION_V2_OPERATION_MODE_CMD_NAME: {
                convertTooltipString = convertRemarkOperationalModeCmd(value);
                break;
            }

            case Common.EVSOLUTION_PD_STAT_NAME: {
                convertTooltipString = convertRemarkPdStat(value);
                break;
            }

            case Common.EVSOLUTION_GEAR_STATE_EHBI_NAME: {
                convertTooltipString = convertRemarkGearStateEhbi(value);
                break;
            }

            default:
                break;
        }
        return convertTooltipString;
    };

    const onChangeZoom = (zoom: any) => {
        onZoomed && onZoomed(zoom);
    };

    return (
        <div>
            <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <div>
                    <CanDataWrapper
                        title="Bms1D9"
                        id="bms1D9"
                        panelOpen={bms1D9PanelOpen}
                        onChangePanelOpen={(panelOpened) => setBms1D9PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataBms1D9}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBms1D9}
                        onChangeTableSelect={onChangeBms1D9}
                        seriesChartDatas={seriesChartDatasBms1D9}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBms1D9ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Bms321"
                        id="bms321"
                        panelOpen={bms321PanelOpen}
                        onChangePanelOpen={(panelOpened) => setBms321PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataBms321}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBms321}
                        onChangeTableSelect={onChangeBms321}
                        seriesChartDatas={seriesChartDatasBms321}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBms321ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Bms322"
                        id="bms322"
                        panelOpen={bms322PanelOpen}
                        onChangePanelOpen={(panelOpened) => setBms322PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataBms322}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBms322}
                        onChangeTableSelect={onChangeBms322}
                        seriesChartDatas={seriesChartDatasBms322}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBms322ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Bms323"
                        id="bms323"
                        panelOpen={bms323PanelOpen}
                        onChangePanelOpen={(panelOpened) => setBms323PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataBms323}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBms323}
                        onChangeTableSelect={onChangeBms323}
                        seriesChartDatas={seriesChartDatasBms323}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBms323ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Bms324"
                        id="bms324"
                        panelOpen={bms324PanelOpen}
                        onChangePanelOpen={(panelOpened) => setBms324PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataBms324}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBms324}
                        onChangeTableSelect={onChangeBms324}
                        seriesChartDatas={seriesChartDatasBms324}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBms324ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Bms325"
                        id="bms325"
                        panelOpen={bms325PanelOpen}
                        onChangePanelOpen={(panelOpened) => setBms325PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataBms325}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBms325}
                        onChangeTableSelect={onChangeBms325}
                        seriesChartDatas={seriesChartDatasBms325}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBms325ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Bms326"
                        id="bms326"
                        panelOpen={bms326PanelOpen}
                        onChangePanelOpen={(panelOpened) => setBms326PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataBms326}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBms326}
                        onChangeTableSelect={onChangeBms326}
                        seriesChartDatas={seriesChartDatasBms326}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBms326ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Mcu1E1"
                        id="mcu1E1"
                        panelOpen={mcu1E1PanelOpen}
                        onChangePanelOpen={(panelOpened) => setMcu1E1PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataMcu1E1}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedMcu1E1}
                        onChangeTableSelect={onChangeMcu1E1}
                        seriesChartDatas={seriesChartDatasMcu1E1}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setMcu1E1ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Vcu1D4"
                        id="vcu1D4"
                        panelOpen={vcu1D4PanelOpen}
                        onChangePanelOpen={(panelOpened) => setVcu1D4PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu1D4}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu1D4}
                        onChangeTableSelect={onChangeVcu1D4}
                        seriesChartDatas={seriesChartDatasVcu1D4}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu1D4ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Vcu1D5"
                        id="vcu1D5"
                        panelOpen={vcu1D5PanelOpen}
                        onChangePanelOpen={(panelOpened) => setVcu1D5PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu1D5}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu1D5}
                        onChangeTableSelect={onChangeVcu1D5}
                        seriesChartDatas={seriesChartDatasVcu1D5}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu1D5ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Evcc341"
                        id="evcc341"
                        panelOpen={evcc341PanelOpen}
                        onChangePanelOpen={(panelOpened) => setEvcc341PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataEvcc341}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedEvcc341}
                        onChangeTableSelect={onChangeEvcc341}
                        seriesChartDatas={seriesChartDatasEvcc341}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setEvcc341ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Evcc343"
                        id="evcc343"
                        panelOpen={evcc343PanelOpen}
                        onChangePanelOpen={(panelOpened) => setEvcc343PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataEvcc343}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedEvcc343}
                        onChangeTableSelect={onChangeEvcc343}
                        seriesChartDatas={seriesChartDatasEvcc343}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setEvcc343ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Ehbi080"
                        id="ehbi080"
                        panelOpen={ehbi080PanelOpen}
                        onChangePanelOpen={(panelOpened) => setEhbi080PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataEhbi080}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedEhbi080}
                        onChangeTableSelect={onChangeEhbi080}
                        seriesChartDatas={seriesChartDatasEhbi080}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setEhbi080ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                    <CanDataWrapper
                        title="Vcu090"
                        id="vcu090"
                        panelOpen={vcu090PanelOpen}
                        onChangePanelOpen={(panelOpened) => setVcu090PanelOpen(panelOpened)}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu090}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu090}
                        onChangeTableSelect={onChangeVcu090}
                        seriesChartDatas={seriesChartDatasVcu090}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu090ChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                </div>
            </Space>
        </div>
    );
}

export default CanDataEVSolutionViewer;
